import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";
import jwtService from "../jwt.service";
//import VuexPersistence from "vuex-persist";

// action types
export const VERIFY_AUTH = "verifyAuth";
export const LOGIN = "login";
export const LOGOUT = "logout";
export const REGISTER = "register";
export const UPDATE_PASSWORD = "updateUser";
export const GET_CURRENT_USER = "getCurrentUser";

// mutation types
export const PURGE_AUTH = "logOut";
export const SET_AUTH = "setUser";

export const SET_INSTITUCION = "setInstitucion";
//Quitar al arreglar el getuser
export const SET_AUTH2 = "setAuth2";

export const SET_TOKEN = "setToken";
export const SET_PASSWORD = "setPassword";
export const SET_ERROR = "setError";
export const SET_CREADOR_DEPARTAMENTAL = "setCreadorDepartamental";
export const SET_CREADOR_DEPARTAMENTAL_VERIFY = "setCreadorDepartamentalFromVerify";
export const SET_CURRENT_USER = "setCurrentUser";
export const SET_CURRENT_ROLES = "setCurrentRoles";

const state = {
  errors: null,
  user: {},
  roles: {},
  currentUser:{},
  currentRoles: {},
  isAuthenticated: !!JwtService.getToken()
};

const getters = {
  currentUser(state) {
    return state.user;
  },

  currentRoles(state) {
    return state.roles;
  },

  isAuthenticated(state) {
    return state.isAuthenticated;
  }
};

const users = [{"id":13,"correoUsuario":"enlace_test@amiguate.com123","estadosId":2,"estado":"Inactivo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Luis Garcia 123","telefono":null,"puestosId":2,"nombrePuesto":"Representante Institución","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":341,"municipio":"Departamento Ficticio Muni Test","deptoCreador":0,"muniInformador":1,"departamentoInformador":23,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\921673879.pdf"},{"id":955,"correoUsuario":"enlace.municipal@amiguate.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Informador Municipal","telefono":null,"puestosId":2,"nombrePuesto":"Representante Institución","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":363,"municipio":"Ficti 22","deptoCreador":0,"muniInformador":412,"departamentoInformador":23,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\519731901.pdf"},{"id":975,"correoUsuario":"mixcodpe@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Pablo Estuardo Quiñónez Arias","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":80,"municipio":"Mixco","deptoCreador":0,"muniInformador":416,"departamentoInformador":7,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\410616851.pdf"},{"id":976,"correoUsuario":"fzeissig@muniguate.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Flor Zeissig","telefono":null,"puestosId":2,"nombrePuesto":"Representante Institución","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":78,"municipio":"Ciudad de Guatemala","deptoCreador":0,"muniInformador":417,"departamentoInformador":7,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1668797834.pdf"},{"id":1177,"correoUsuario":"juanperez@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Juan Pérez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":342,"municipio":"Ficti 1","deptoCreador":0,"muniInformador":418,"departamentoInformador":23,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1629378601.pdf"},{"id":1178,"correoUsuario":"jalfaro12@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Jose Alfaro","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":342,"municipio":"Ficti 1","deptoCreador":0,"muniInformador":419,"departamentoInformador":23,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\588862523.pdf"},{"id":1179,"correoUsuario":"chofolp@gmail.com","estadosId":2,"estado":"Inactivo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":" creador_departamental2@amiguate.com","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":210,"municipio":"Santa Cruz del Quiché","deptoCreador":0,"muniInformador":420,"departamentoInformador":14,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\753341836.pdf"},{"id":1180,"correoUsuario":"stalindan@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Estalin Alberto Reyes Pineda","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":82,"municipio":"San José del Golfo","deptoCreador":0,"muniInformador":421,"departamentoInformador":7,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1508105685.pdf"},{"id":1181,"correoUsuario":"coliva@muniejemplo.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Cristian Oliva","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":342,"municipio":"Ficti 1","deptoCreador":0,"muniInformador":422,"departamentoInformador":23,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\295015168.pdf"},{"id":1182,"correoUsuario":"josemart@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Jose Martinez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":345,"municipio":"Ficti 4","deptoCreador":0,"muniInformador":423,"departamentoInformador":23,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1278153743.pdf"},{"id":1190,"correoUsuario":"abdiaschacajchiti@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Miguel Daimer Abdías Chacaj Chiti","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":305,"municipio":"Pueblo Nuevo","deptoCreador":0,"muniInformador":424,"departamentoInformador":20,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1200882361.pdf"},{"id":1193,"correoUsuario":"mariamsagui@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"María Magdalena Sagüi Caal","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":87,"municipio":"San Pedro Sacatepéquez","deptoCreador":0,"muniInformador":425,"departamentoInformador":7,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1344191366.pdf"},{"id":1194,"correoUsuario":"hernandezsh2526@gmail.com","estadosId":2,"estado":"Inactivo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Dalia Maria Sandoval Hernández","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":60,"municipio":"Sansare","deptoCreador":0,"muniInformador":426,"departamentoInformador":5,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1773037227.pdf"},{"id":1195,"correoUsuario":"shenysal@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Sheny Elizabeth Sal Pop ","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":29,"municipio":"Parramos","deptoCreador":0,"muniInformador":427,"departamentoInformador":3,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\995226981.pdf"},{"id":1196,"correoUsuario":"sarahiguerra87@hotmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Elvia  Alexia Sarahi Guerra Álvarez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":340,"municipio":"Zacapa","deptoCreador":0,"muniInformador":428,"departamentoInformador":22,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\524840423.pdf"},{"id":1198,"correoUsuario":"deleonwilliam398@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"William José Alessandro Botzotz de León ","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":28,"municipio":"El Tejar","deptoCreador":0,"muniInformador":429,"departamentoInformador":3,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1254607041.pdf"},{"id":1199,"correoUsuario":"jorgetax_27@hotmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Jorge Abel Tax Aju","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":313,"municipio":"San José La Máquina","deptoCreador":0,"muniInformador":430,"departamentoInformador":20,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\936163283.pdf"},{"id":1200,"correoUsuario":"unidaddeinformacionpublica6@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Bryan Josué Juárez lópez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":310,"municipio":"San Francisco Zapotitlán","deptoCreador":0,"muniInformador":431,"departamentoInformador":20,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\2049272104.pdf"},{"id":1201,"correoUsuario":"herreramleonel30@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Leonel Antonio Herrera Mazariegos","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":23,"municipio":"San Jerónimo","deptoCreador":0,"muniInformador":432,"departamentoInformador":2,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\712816608.pdf"},{"id":1202,"correoUsuario":"kelito7890@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Angel Francisco García Ortíz","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":20,"municipio":"Purulhá","deptoCreador":0,"muniInformador":433,"departamentoInformador":2,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1497280479.pdf"},{"id":1203,"correoUsuario":"informacionpublicasanagustinac@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"José Armando Méndez Ortega","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":56,"municipio":"San Agustín Acasaguastlán","deptoCreador":0,"muniInformador":434,"departamentoInformador":5,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\881840655.pdf"},{"id":1204,"correoUsuario":"mayrajuracan8@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"mayra.juracan","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":282,"municipio":"Concepción","deptoCreador":0,"muniInformador":435,"departamentoInformador":19,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\712303912.pdf"},{"id":1205,"correoUsuario":"tojincastrom@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"miguel.tojin","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":283,"municipio":"Nahualá","deptoCreador":0,"muniInformador":436,"departamentoInformador":19,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\516472002.pdf"},{"id":1206,"correoUsuario":"j2orellana@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"jose.orellana","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":286,"municipio":"San Antonio Palopó","deptoCreador":0,"muniInformador":437,"departamentoInformador":19,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\2069481253.pdf"},{"id":1207,"correoUsuario":"marvinkikegomez@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"marvin.gomez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":289,"municipio":"San Lucas Tolimán","deptoCreador":0,"muniInformador":438,"departamentoInformador":19,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1566797781.pdf"},{"id":1208,"correoUsuario":"rennytambriz@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"renny.chox","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":290,"municipio":"San Marcos La Laguna","deptoCreador":0,"muniInformador":439,"departamentoInformador":19,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1800395102.PDF"},{"id":1209,"correoUsuario":"yohanafrancinybaran21@gmail.com","estadosId":2,"estado":"Inactivo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Yohana Franciny Barán Escobar","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":311,"municipio":"San Gabriel","deptoCreador":0,"muniInformador":440,"departamentoInformador":20,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\97125836.pdf"},{"id":1210,"correoUsuario":"ajtijpedrito@yahoo.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"pedro.gomez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":293,"municipio":"Santa Catarina Ixtahuacán","deptoCreador":0,"muniInformador":441,"departamentoInformador":19,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1309218588.pdf"},{"id":1211,"correoUsuario":"dmpsantacruzlalaguna0714@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"jose.culum","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":296,"municipio":"Santa Cruz La Laguna","deptoCreador":0,"muniInformador":442,"departamentoInformador":19,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\700627795.pdf"},{"id":1212,"correoUsuario":"oraliaochoa@hotmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"elsa.ochoa","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":297,"municipio":"Santa Lucía Utatlán","deptoCreador":0,"muniInformador":443,"departamentoInformador":19,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\2031596512.pdf"},{"id":1213,"correoUsuario":"lest.sosa7@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"luis.sosa","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":298,"municipio":"Santa María Visitación","deptoCreador":0,"muniInformador":444,"departamentoInformador":19,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\2011425517.pdf"},{"id":1214,"correoUsuario":"1jorge.mejia@muniesquipulas.gob.gt","estadosId":2,"estado":"Inactivo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"1Jorge Luis Mejía Rodríguez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":45,"municipio":"Esquipulas","deptoCreador":0,"muniInformador":445,"departamentoInformador":4,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1979210917.pdf"},{"id":1215,"correoUsuario":"1granadospadillamc@gmail.com","estadosId":2,"estado":"Inactivo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"1María Carolina Granados Padilla","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":43,"municipio":"Chiquimula","deptoCreador":0,"muniInformador":446,"departamentoInformador":4,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1383587890.pdf"},{"id":1216,"correoUsuario":"1omdmunisj@gmail.com","estadosId":2,"estado":"Inactivo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"1Karla María Sagastume Espino De Coronado","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":51,"municipio":"San José la Arada","deptoCreador":0,"muniInformador":447,"departamentoInformador":4,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1987063975.pdf"},{"id":1217,"correoUsuario":"1estuardomiguel83@gmail.com","estadosId":2,"estado":"Inactivo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"1Miguel Estuardo García Gonzáles","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":52,"municipio":"San Juan Ermita","deptoCreador":0,"muniInformador":448,"departamentoInformador":4,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\447336766.pdf"},{"id":1218,"correoUsuario":"municatarina2020@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Alex Estiven Santos Rodriguez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":239,"municipio":"Catarina","deptoCreador":0,"muniInformador":449,"departamentoInformador":17,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1993966975.pdf"},{"id":1219,"correoUsuario":"www.gabyvasquezmiranda123@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Gabriela Miranda Vásquez de Pérez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":240,"municipio":"Comitancillo","deptoCreador":0,"muniInformador":450,"departamentoInformador":17,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\2091870670.pdf"},{"id":1220,"correoUsuario":"selvinepg1227@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Selvin Johel López Orozco","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":244,"municipio":"Esquipulas Palo Gordo","deptoCreador":0,"muniInformador":451,"departamentoInformador":17,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\894928500.pdf"},{"id":1221,"correoUsuario":"sanantonio.uipm@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Roberto Carlos Garcia Cuc","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":253,"municipio":"San Antonio Sacatepéquez","deptoCreador":0,"muniInformador":452,"departamentoInformador":17,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\515759018.pdf"},{"id":1222,"correoUsuario":"mildrenlcm672@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Mildren Lorena Cardona Mejía","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":261,"municipio":"San Pedro Sacatepéquez","deptoCreador":0,"muniInformador":453,"departamentoInformador":17,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\2037969191.pdf"},{"id":1223,"correoUsuario":"leonidasaguilar1205@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Nelson Leonidas Aguilar de Paz","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":259,"municipio":"San Miguel Ixtahuacán","deptoCreador":0,"muniInformador":454,"departamentoInformador":17,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1323378534.pdf"},{"id":1224,"correoUsuario":"mayrobleromo@hotmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Maira Yanel Roblero Morales","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":263,"municipio":"Sibinal","deptoCreador":0,"muniInformador":455,"departamentoInformador":17,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\2113656092.pdf"},{"id":1225,"correoUsuario":"alexismirandamejia@icloud.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Ronaldo Alexis Miranda Mejía","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":249,"municipio":"Nuevo Progreso","deptoCreador":0,"muniInformador":456,"departamentoInformador":17,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1197986893.pdf"},{"id":1226,"correoUsuario":"yenica2016@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Jenica Maely Pérez Méndez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":250,"municipio":"Ocós","deptoCreador":0,"muniInformador":457,"departamentoInformador":17,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\414052336.pdf"},{"id":1227,"correoUsuario":"carloshl.code21@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Carlos Enrique Herrera López","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":312,"municipio":"San José El Idolo","deptoCreador":0,"muniInformador":458,"departamentoInformador":20,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1088622659.pdf"},{"id":1228,"correoUsuario":"ixcaya26@gmail.com","estadosId":2,"estado":"Inactivo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"alicia.ratzam","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":291,"municipio":"San Pablo La Laguna","deptoCreador":0,"muniInformador":459,"departamentoInformador":19,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1296469700.pdf"},{"id":1229,"correoUsuario":"lindanimacachilopez@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"linda.nimacachi","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":294,"municipio":"Santa Catarina Palopó","deptoCreador":0,"muniInformador":460,"departamentoInformador":19,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1352928399.pdf"},{"id":1230,"correoUsuario":"munisanpablosanmarcos@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"José Ramón Mérida Guzmán","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":260,"municipio":"San Pablo","deptoCreador":0,"muniInformador":461,"departamentoInformador":17,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\926682032.pdf"},{"id":1231,"correoUsuario":"senaidapecher@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"astrid.quisquina","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":300,"municipio":"Sololá","deptoCreador":0,"muniInformador":462,"departamentoInformador":19,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1245971374.pdf"},{"id":1232,"correoUsuario":"donis.caniz@segeplan.gob.gt","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"benja.caniz","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":300,"municipio":"Sololá","deptoCreador":0,"muniInformador":463,"departamentoInformador":19,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\485894915.pdf"},{"id":1233,"correoUsuario":"oferam81@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Ofelia Ramos Lorenzo","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":245,"municipio":"Ixchiguán","deptoCreador":0,"muniInformador":464,"departamentoInformador":17,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\817618652.pdf"},{"id":1234,"correoUsuario":"elmarescalana@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Harvid Vinicio Gálvez Escalante","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":256,"municipio":"San José Ojetenam","deptoCreador":0,"muniInformador":465,"departamentoInformador":17,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\277702164.pdf"},{"id":1235,"correoUsuario":"pablotax734@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Pablo David Villegas Tax","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":33,"municipio":"San Andrés Itzapa","deptoCreador":0,"muniInformador":466,"departamentoInformador":3,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1794375382.pdf"},{"id":1236,"correoUsuario":"tdcingenieria19@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Werner Ivan Coronado Santos","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":254,"municipio":"San Cristóbal Cucho","deptoCreador":0,"muniInformador":467,"departamentoInformador":17,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1208989282.pdf"},{"id":1237,"correoUsuario":"municipalidadlablanca@outlook.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Aldo Lorenzo de León Maldonado","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":246,"municipio":"La Blanca","deptoCreador":0,"muniInformador":468,"departamentoInformador":17,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1805218287.pdf"},{"id":1238,"correoUsuario":"anitamartinezm0@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Grislin Anayanci Martínez Morales","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":336,"municipio":"San Diego","deptoCreador":0,"muniInformador":469,"departamentoInformador":22,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1671440142.pdf"},{"id":1239,"correoUsuario":"gerente@munilaunion.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Rene Mardoqueo Casasola Santisteban","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":334,"municipio":"La Unión","deptoCreador":0,"muniInformador":470,"departamentoInformador":22,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\648838441.pdf"},{"id":1240,"correoUsuario":"maryortizv84@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Maritza Ortiz Veliz","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":57,"municipio":"San Antonio La Paz","deptoCreador":0,"muniInformador":471,"departamentoInformador":5,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\273238387.pdf"},{"id":1241,"correoUsuario":"info@municamotan.gob.gt","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Yeimy Sucely Ramos Ávila","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":42,"municipio":"Camotán","deptoCreador":0,"muniInformador":472,"departamentoInformador":4,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\42764250.pdf"},{"id":1242,"correoUsuario":"dmspmunisalama@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Astrid Maria del Carmen Lopez Gonzales","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":22,"municipio":"Salamá","deptoCreador":0,"muniInformador":473,"departamentoInformador":2,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1228316157.pdf"},{"id":1243,"correoUsuario":"perezjuarezj174@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Julia Pérez Juárez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":18,"municipio":"Cubulco","deptoCreador":0,"muniInformador":474,"departamentoInformador":2,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\126044331.pdf"},{"id":1244,"correoUsuario":"lgim2014@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Gustavo Rolando Mayén García","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":24,"municipio":"San Miguel Chicaj","deptoCreador":0,"muniInformador":475,"departamentoInformador":2,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\386352292.pdf"},{"id":1245,"correoUsuario":"malbertubin@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Mario Alberto Tubín Ruyán","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":38,"municipio":"Santa Cruz Balanyá","deptoCreador":0,"muniInformador":476,"departamentoInformador":3,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1678253076.pdf"},{"id":1246,"correoUsuario":"joamm1970@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"José Antonio Martínez y Martínez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":338,"municipio":"Teculután","deptoCreador":0,"muniInformador":477,"departamentoInformador":22,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\2008027565.pdf"},{"id":1247,"correoUsuario":"josuerigoberto77@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Josue Rogoberto Barrios Ochoa","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":262,"municipio":"San Rafael Pie de la Cuesta","deptoCreador":0,"muniInformador":478,"departamentoInformador":17,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\407835208.pdf"},{"id":1248,"correoUsuario":"apariciosacuj@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"carlos.sacuj","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":285,"municipio":"San Andrés Semetabaj","deptoCreador":0,"muniInformador":479,"departamentoInformador":19,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\371404220.pdf"},{"id":1249,"correoUsuario":"amendozagt@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"celso.mendoza","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":288,"municipio":"San Juan La Laguna","deptoCreador":0,"muniInformador":480,"departamentoInformador":19,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\924895666.pdf"},{"id":1250,"correoUsuario":"edgardmp95@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"edgar.chocoy","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":295,"municipio":"Santa Clara La Laguna","deptoCreador":0,"muniInformador":481,"departamentoInformador":19,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\907108748.pdf"},{"id":1251,"correoUsuario":"auditoria2mido@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Juan Carlos Jiménez Pinto","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":331,"municipio":"Estanzuela","deptoCreador":0,"muniInformador":482,"departamentoInformador":22,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\618710964.pdf"},{"id":1252,"correoUsuario":"hercocadez@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Oscar Estuardo Escobar Hernández","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":238,"municipio":"Ayutla","deptoCreador":0,"muniInformador":483,"departamentoInformador":17,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\204770441.pdf"},{"id":1253,"correoUsuario":"mazariegosa962@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Aztri Marili Mazariegos Cax","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":266,"municipio":"Tajumulco","deptoCreador":0,"muniInformador":484,"departamentoInformador":17,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1008883186.pdf"},{"id":1254,"correoUsuario":"lisscastanedack@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Claudia Lissette Castañeda Tista","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":333,"municipio":"Huité","deptoCreador":0,"muniInformador":485,"departamentoInformador":22,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\2013481226.pdf"},{"id":1255,"correoUsuario":"dianaxum029@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Diana Evelyn Xum Solval","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":307,"municipio":"Samayac","deptoCreador":0,"muniInformador":486,"departamentoInformador":20,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1636820170.pdf"},{"id":1256,"correoUsuario":"infopublicamuni16@gmail.com","estadosId":2,"estado":"Inactivo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Yosselyn Abigail Estrada Castañeda","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":308,"municipio":"San Antonio Suchitepéquez","deptoCreador":0,"muniInformador":487,"departamentoInformador":20,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1504421376.pdf"},{"id":1257,"correoUsuario":"tahaytzajcristobal@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"cristobal.tahay","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":287,"municipio":"San José Chacayá","deptoCreador":0,"muniInformador":488,"departamentoInformador":19,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\27148884.pdf"},{"id":1258,"correoUsuario":"duarte.manuelfelipe@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Manuel Felipe Duarte Ávila","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":339,"municipio":"Usumatlán","deptoCreador":0,"muniInformador":489,"departamentoInformador":22,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1635478592.pdf"},{"id":1259,"correoUsuario":"brandonmolinalopez15@hotmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Brandon Alexander López Molina","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":330,"municipio":"Cabañas","deptoCreador":0,"muniInformador":490,"departamentoInformador":22,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\182316950.pdf"},{"id":1260,"correoUsuario":"lsimong1@miumg.edu.gt","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Lesly Gabriela Simón Gómez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":247,"municipio":"La Reforma","deptoCreador":0,"muniInformador":491,"departamentoInformador":17,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1948211928.pdf"},{"id":1261,"correoUsuario":"ronaff15@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Ronal Federico Santos Chivalan","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":316,"municipio":"San Miguel Panán","deptoCreador":0,"muniInformador":492,"departamentoInformador":20,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1096622204.pdf"},{"id":1262,"correoUsuario":"arqglucas@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Hermilia Genoveva Lucas Mazariegos","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":61,"municipio":"Escuintla","deptoCreador":0,"muniInformador":493,"departamentoInformador":6,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\69656003.pdf"},{"id":1263,"correoUsuario":"secretariamunicipalsantaluciac@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Obel Isai de la Cruz Vásquez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":71,"municipio":"Santa Lucía Cotzumalguapa","deptoCreador":0,"muniInformador":494,"departamentoInformador":6,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\2042842039.pdf"},{"id":1264,"correoUsuario":"secretariamunidemoescuintla@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Angelica Odilia de la Cruz Ramírez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":64,"municipio":"La Democracia","deptoCreador":0,"muniInformador":495,"departamentoInformador":6,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\944863614.pdf"},{"id":1265,"correoUsuario":"jorgepu3132@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Jorge Antonio Elias Pú Castro","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":73,"municipio":"Siquinalá","deptoCreador":0,"muniInformador":496,"departamentoInformador":6,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\381813182.pdf"},{"id":1266,"correoUsuario":"rocakl2323@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Karla Leticia Roca Barrios ","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":66,"municipio":"Masagua","deptoCreador":0,"muniInformador":497,"departamentoInformador":6,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\420636327.pdf"},{"id":1267,"correoUsuario":"lsandovaldavila@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Luis Alfredo Sandoval Dávila","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":74,"municipio":"Tiquisate","deptoCreador":0,"muniInformador":498,"departamentoInformador":6,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1892071110.pdf"},{"id":1268,"correoUsuario":"dignolomendez@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"José Dignolo Méndez Colindres","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":65,"municipio":"La Gomera","deptoCreador":0,"muniInformador":499,"departamentoInformador":6,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1920284890.pdf"},{"id":1269,"correoUsuario":"guanagazapa.secretariamunicipal@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Angela Graciela Alvarado Gaitan ","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":62,"municipio":"Guanagazapa","deptoCreador":0,"muniInformador":500,"departamentoInformador":6,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1082072530.pdf"},{"id":1270,"correoUsuario":"ealvarengaa@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Jesús Eugenio Alvarenga Auceda","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":69,"municipio":"San José","deptoCreador":0,"muniInformador":501,"departamentoInformador":6,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1471775846.jpeg"},{"id":1271,"correoUsuario":"ryr1997@hotmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"María Raquel Castillo Sales","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":63,"municipio":"Iztapa","deptoCreador":0,"muniInformador":502,"departamentoInformador":6,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\726334525.pdf"},{"id":1272,"correoUsuario":"eduardocursin30@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Manuel Eduardo López Cursin","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":68,"municipio":"Palín","deptoCreador":0,"muniInformador":503,"departamentoInformador":6,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\43018923.pdf"},{"id":1273,"correoUsuario":"munisanvicentepacaya@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Quintín Marvin Baldetti Pérez ","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":70,"municipio":"San Vicente Pacaya","deptoCreador":0,"muniInformador":504,"departamentoInformador":6,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1220787019.pdf"},{"id":1274,"correoUsuario":"muninuevaconcepcion13@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Jonathan Javier Guerrero Campos","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":67,"municipio":"Nueva Concepción","deptoCreador":0,"muniInformador":505,"departamentoInformador":6,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1241855776.pdf"},{"id":1275,"correoUsuario":"raulsosa55@hotmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Raul Sosa Coronado","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":72,"municipio":"Sipacate","deptoCreador":0,"muniInformador":506,"departamentoInformador":6,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1216706778.pdf"},{"id":1279,"correoUsuario":"enlace.municipal2@amiguate.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Enlace Municipal 2","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":343,"municipio":"Ficti 2","deptoCreador":0,"muniInformador":507,"departamentoInformador":23,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1743952337.pdf"},{"id":1280,"correoUsuario":"guatemala@amiguate.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Guatemala","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":342,"municipio":"Ficti 1","deptoCreador":0,"muniInformador":508,"departamentoInformador":23,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1280040943.pdf"},{"id":1281,"correoUsuario":"elprogreso@amiguate.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"El Progreso","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":343,"municipio":"Ficti 2","deptoCreador":0,"muniInformador":509,"departamentoInformador":23,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\883839919.pdf"},{"id":1282,"correoUsuario":"abmichaeltomas@hotmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Abner Michael Tomás López","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":243,"municipio":"El Tumbador","deptoCreador":0,"muniInformador":510,"departamentoInformador":17,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\811915357.pdf"},{"id":1283,"correoUsuario":"karlilyperez4@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Karlily Arleth Escalante Pérez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":255,"municipio":"San José El Rodeo","deptoCreador":0,"muniInformador":511,"departamentoInformador":17,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1731448299.pdf"},{"id":1284,"correoUsuario":"renata92barrera@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Yoselin Renata Barrera López","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":248,"municipio":"Malacatán","deptoCreador":0,"muniInformador":512,"departamentoInformador":17,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1798308547.pdf"},{"id":1285,"correoUsuario":"rudyedlop27@hotmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Rudy Eduardo López García","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":302,"municipio":"Cuyotenango","deptoCreador":0,"muniInformador":513,"departamentoInformador":20,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1676537955.pdf"},{"id":1286,"correoUsuario":"dvinicio199@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Vinicio Basilio de León Godinez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":242,"municipio":"El Quetzal","deptoCreador":0,"muniInformador":514,"departamentoInformador":17,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1688082183.pdf"},{"id":1287,"correoUsuario":"sharonsalvador910@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Ashly Sharon Salvador Matías","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":257,"municipio":"San Lorenzo","deptoCreador":0,"muniInformador":515,"departamentoInformador":17,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\14312422.pdf"},{"id":1288,"correoUsuario":"1jandregcastillo@gmail.com","estadosId":2,"estado":"Inactivo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"1Jerlyn Jasmine Castillo Mayorga","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":48,"municipio":"Olopa","deptoCreador":0,"muniInformador":516,"departamentoInformador":4,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\739802763.pdf"},{"id":1289,"correoUsuario":"1ladyperez.705@gmail.com","estadosId":2,"estado":"Inactivo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"1Cinthia Ladysol Pérez Rámos","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":50,"municipio":"San Jacinto","deptoCreador":0,"muniInformador":517,"departamentoInformador":4,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\736283049.pdf"},{"id":1290,"correoUsuario":"1julioeovides91@gmail.com","estadosId":2,"estado":"Inactivo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"1Julio Ernesto Ortiz Vides","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":46,"municipio":"Ipala","deptoCreador":0,"muniInformador":518,"departamentoInformador":4,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\410347359.pdf"},{"id":1291,"correoUsuario":"rpalacios@scp.gob.gt","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Rodrigo Francisco Palacios Lemus","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":89,"municipio":"Santa Catarina Pinula","deptoCreador":0,"muniInformador":519,"departamentoInformador":7,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\556296447.pdf"},{"id":1292,"correoUsuario":"maryp7695@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Onelia Marisol Pérez Pérez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":265,"municipio":"Tacaná","deptoCreador":0,"muniInformador":520,"departamentoInformador":17,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1490728715.pdf"},{"id":1293,"correoUsuario":"williams.uaip@munidetejutla.gob.gt","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Williams Raúl Ramírez Canay","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":267,"municipio":"Tejutla","deptoCreador":0,"muniInformador":521,"departamentoInformador":17,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\588010482.pdf"},{"id":1294,"correoUsuario":"hernandezdh2526@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Dalia Maria Sandoval Hernández","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":60,"municipio":"Sansare","deptoCreador":0,"muniInformador":522,"departamentoInformador":5,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\926113261.pdf"},{"id":1295,"correoUsuario":"secremorazan0202@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Katerin Vanessa Gutierrez Catalán ","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":55,"municipio":"Morazán","deptoCreador":0,"muniInformador":523,"departamentoInformador":5,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1477794244.jpeg"},{"id":1296,"correoUsuario":"jorgemariodeleon1986@hotmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Jorge Mario de León Girón ","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":54,"municipio":"Guastatoya","deptoCreador":0,"muniInformador":524,"departamentoInformador":5,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1634779511.pdf"},{"id":1297,"correoUsuario":"gutierrezmariano071@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Jefry Elixsalen Gutiérrez Aldana","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":58,"municipio":"San Cristóbal Acasaguastlán","deptoCreador":0,"muniInformador":525,"departamentoInformador":5,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1922399416.pdf"},{"id":1298,"correoUsuario":"ramosdgr25@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Erick Junior Ramos Enríquez ","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":59,"municipio":"Sanarate","deptoCreador":0,"muniInformador":526,"departamentoInformador":5,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1162283298.pdf"},{"id":1299,"correoUsuario":"mazariegosyovana@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Joshefin Yovana Anary Mazariegos Duarte","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":26,"municipio":"Acatenango","deptoCreador":0,"muniInformador":527,"departamentoInformador":3,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\287339144.pdf"},{"id":1300,"correoUsuario":"fernaeli13@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Damaris Fernanda Elias López ","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":36,"municipio":"San Martín Jilotepeque","deptoCreador":0,"muniInformador":528,"departamentoInformador":3,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1604457589.pdf"},{"id":1301,"correoUsuario":"armandosotz12@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Sergio Armando Sotz Quill","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":34,"municipio":"San José Poaquíl","deptoCreador":0,"muniInformador":529,"departamentoInformador":3,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\595395771.pdf"},{"id":1302,"correoUsuario":"miguelajpop@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Glendo Miguel Ajpop Cujcuj","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":31,"municipio":"Patzún","deptoCreador":0,"muniInformador":530,"departamentoInformador":3,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1035127287.pdf"},{"id":1303,"correoUsuario":"ompyepocapa@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Milvia Dianira Xia Boyo","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":40,"municipio":"San Pedro Yepocapa","deptoCreador":0,"muniInformador":531,"departamentoInformador":3,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1323884425.pdf"},{"id":1304,"correoUsuario":"omj@munipochuta.gob.gt","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Kevin Alexander Álvares Acuta","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":32,"municipio":"San Miguel Pochuta","deptoCreador":0,"muniInformador":532,"departamentoInformador":3,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\307976744.pdf"},{"id":1305,"correoUsuario":"ximenacarias460@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Dulce Ximena Carias Solís","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":53,"municipio":"El Jícaro","deptoCreador":0,"muniInformador":533,"departamentoInformador":5,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\140429135.pdf"},{"id":1306,"correoUsuario":"1secretaria@muniquezaltepeque.gob.gt","estadosId":2,"estado":"Inactivo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"1Mirna Nataly López Archila","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":49,"municipio":"Quetzaltepeque","deptoCreador":0,"muniInformador":534,"departamentoInformador":4,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\811456720.pdf"},{"id":1307,"correoUsuario":"ruarq18053@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Ricky Ugalde","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":303,"municipio":"Mazatenango","deptoCreador":0,"muniInformador":535,"departamentoInformador":20,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\252708609.pdf"},{"id":1308,"correoUsuario":"hlaraso@yahoo.es","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Hugo Leonel Lara Solís","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":306,"municipio":"Río Bravo","deptoCreador":0,"muniInformador":536,"departamentoInformador":20,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\384542532.pdf"},{"id":1309,"correoUsuario":"abelbravila0@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Abel Fernando Bravila Stzep","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":251,"municipio":"Pajapita","deptoCreador":0,"muniInformador":537,"departamentoInformador":17,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\870531024.pdf"},{"id":1310,"correoUsuario":"teudychun@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Maddelin Melanie Teudicely Chún Nolasco","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":241,"municipio":"Concepción Tutuapa","deptoCreador":0,"muniInformador":538,"departamentoInformador":17,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\605382403.pdf"},{"id":1311,"correoUsuario":"jaironain1@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Jairo Nain Vásquez García","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":252,"municipio":"Río Blanco","deptoCreador":0,"muniInformador":539,"departamentoInformador":17,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1717512841.pdf"},{"id":1312,"correoUsuario":"emilioandresc4@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Emilio Andres Cuxil Garcia","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":35,"municipio":"San Juan Comalapa","deptoCreador":0,"muniInformador":540,"departamentoInformador":3,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1930350971.pdf"},{"id":1313,"correoUsuario":"munisanlorenzosuchitepequez@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Mildred Lorena Salvador De León","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":315,"municipio":"San Lorenzo","deptoCreador":0,"muniInformador":541,"departamentoInformador":20,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1776707225.pdf"},{"id":1314,"correoUsuario":"rankingdespacho@amatitlan.gob.gt","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Alba Esther del Cid Rodríguez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":75,"municipio":"Amatitlán","deptoCreador":0,"muniInformador":542,"departamentoInformador":7,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\359945802.pdf"},{"id":1315,"correoUsuario":"civillavicencios@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Carlos Ivan Villavicencio Sandoval ","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":88,"municipio":"San Raymundo","deptoCreador":0,"muniInformador":543,"departamentoInformador":7,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1008393328.pdf"},{"id":1316,"correoUsuario":"uot@munisanjosepinula.gob.gt","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Francisco Antonio Neftali Reyes Franco","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":83,"municipio":"San José Pinula","deptoCreador":0,"muniInformador":544,"departamentoInformador":7,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\751260369.pdf"},{"id":1317,"correoUsuario":"byron2016b@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Byron Antonio Piztun Hernández","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":76,"municipio":"Chinautla","deptoCreador":0,"muniInformador":545,"departamentoInformador":7,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1144168422.pdf"},{"id":1318,"correoUsuario":"estadisticasocioeconomicamvc@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"María Fernanda Gonzáles Yancor","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":90,"municipio":"Villa Canales","deptoCreador":0,"muniInformador":546,"departamentoInformador":7,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1772906020.pdf"},{"id":1319,"correoUsuario":"marlendcge@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Marlen Yesenia del Cid Gómez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":81,"municipio":"Palencia","deptoCreador":0,"muniInformador":547,"departamentoInformador":7,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\64369450.pdf"},{"id":1320,"correoUsuario":"hector.floresgarcia@munifraijanes.gob.gt","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Héctor Alejandro Flores García","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":79,"municipio":"Fraijanes","deptoCreador":0,"muniInformador":548,"departamentoInformador":7,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\489763284.pdf"},{"id":1321,"correoUsuario":"keneth200100@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Keneth Daniel Aguilar Fernández","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":258,"municipio":"San Marcos","deptoCreador":0,"muniInformador":549,"departamentoInformador":17,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\284641687.pdf"},{"id":1322,"correoUsuario":"Avramspu@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":" José Abraham Punay Xocoxic","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":77,"municipio":"Chuarrancho","deptoCreador":0,"muniInformador":550,"departamentoInformador":7,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\125874521.pdf"},{"id":1323,"correoUsuario":"alexander2024pc@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Yubini Alexander Perez Cruz","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":264,"municipio":"Sipacapa","deptoCreador":0,"muniInformador":551,"departamentoInformador":17,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\739581414.PDF"},{"id":1324,"correoUsuario":"simestrag@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Simón Estrada Guerra","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":30,"municipio":"Patzicía","deptoCreador":0,"muniInformador":552,"departamentoInformador":3,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1841433969.pdf"},{"id":1325,"correoUsuario":"diegochumil33@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Juan Diego Antonio Chumil Macario","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":39,"municipio":"Tecpán","deptoCreador":0,"muniInformador":553,"departamentoInformador":3,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1360816004.pdf"},{"id":1326,"correoUsuario":"dmpzaragoza24@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Walter Rene Chicol Peren","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":41,"municipio":"Zaragoza","deptoCreador":0,"muniInformador":554,"departamentoInformador":3,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1884937953.pdf"},{"id":1327,"correoUsuario":"informacionpublicamunispa.16@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Michelle Alexandra Rodríguez Marroquin","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":86,"municipio":"San Pedro Ayampuc","deptoCreador":0,"muniInformador":555,"departamentoInformador":7,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\525136390.pdf"},{"id":1328,"correoUsuario":"sindicos@munisanjuansac.org","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Andrea del Rocio Alonzo Corado ","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":84,"municipio":"San Juan Sacatepéquez","deptoCreador":0,"muniInformador":556,"departamentoInformador":7,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1425982292.pdf"},{"id":1329,"correoUsuario":"juanmi_182@hotmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Juan Miguel Orellana","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":85,"municipio":"San Miguel Petapa","deptoCreador":0,"muniInformador":557,"departamentoInformador":7,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1264528393.pdf"},{"id":1330,"correoUsuario":"hectorsecay@outlook.es","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Hector David Secay Pors","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":91,"municipio":"Villa Nueva","deptoCreador":0,"muniInformador":558,"departamentoInformador":7,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1748900178.pdf"},{"id":1331,"correoUsuario":"1wiliam.garcia1985@gmail.com","estadosId":2,"estado":"Inactivo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"1Wiliam García Pérez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":47,"municipio":"Jocotán","deptoCreador":0,"muniInformador":559,"departamentoInformador":4,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1697746337.pdf"},{"id":1332,"correoUsuario":"1info@municoncepcionlasminas.gob.gt","estadosId":2,"estado":"Inactivo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"1Wuendy Olivia Portillo Lémus","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":44,"municipio":"Concepción Las Minas","deptoCreador":0,"muniInformador":560,"departamentoInformador":4,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1843276635.pdf"},{"id":1333,"correoUsuario":"desarrolloterritoial2428@outlook.com123","estadosId":2,"estado":"Inactivo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Mirna Janeth Ramos de Bardales123","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":332,"municipio":"Gualán","deptoCreador":0,"muniInformador":561,"departamentoInformador":22,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1941938320.pdf"},{"id":1334,"correoUsuario":"secretariamunirio@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Elder Adalberto Calderón Saquic","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":335,"municipio":"Río Hondo","deptoCreador":0,"muniInformador":562,"departamentoInformador":22,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1687434368.pdf"},{"id":1335,"correoUsuario":"tobarliseth7@gmail.com123","estadosId":2,"estado":"Inactivo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Dayana Liseth Tobar Ipiña123","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":337,"municipio":"San Jorge","deptoCreador":0,"muniInformador":563,"departamentoInformador":22,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\405407332.pdf"},{"id":1336,"correoUsuario":"carolherrerag1973@yahoo.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Cárol Yvonne Herrera Guevara","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":97,"municipio":"Huehuetenango","deptoCreador":0,"muniInformador":564,"departamentoInformador":8,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1560925921.pdf"},{"id":1337,"correoUsuario":"marycarmentello@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Mary Carmen Tello Herrera","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":93,"municipio":"Chiantla","deptoCreador":0,"muniInformador":565,"departamentoInformador":8,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\2100459846.pdf"},{"id":1338,"correoUsuario":"olaipmunispn@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Dilma Migdalia Martínez Martínez de Cúmes","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":111,"municipio":"San Pedro Nécta","deptoCreador":0,"muniInformador":566,"departamentoInformador":8,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1263868511.pdf"},{"id":1339,"correoUsuario":"uaipmunijacal@outlook.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Fredman Vinicio Delgado Rojas","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":98,"municipio":"Jacaltenango","deptoCreador":0,"muniInformador":567,"departamentoInformador":8,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1190935491.pdf"},{"id":1340,"correoUsuario":"kndygonzalez693@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Cándida Eloísa Díaz González","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":112,"municipio":"San Pedro Soloma","deptoCreador":0,"muniInformador":568,"departamentoInformador":8,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\621624811.pdf"},{"id":1341,"correoUsuario":"solmarti1995@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Amanda Soledad Ortiz Martinez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":106,"municipio":"San Ildefonso Ixtahuacán","deptoCreador":0,"muniInformador":569,"departamentoInformador":8,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1642730293.pdf"},{"id":1342,"correoUsuario":"patygranados67@yahoo.es","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Edilma Patricia Granados de Martinez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":99,"municipio":"La Democracia","deptoCreador":0,"muniInformador":570,"departamentoInformador":8,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1470826698.pdf"},{"id":1343,"correoUsuario":"josemarcos_pm@hotmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"José Marcos Pascual Manuel","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":110,"municipio":"San Miguel Acatán","deptoCreador":0,"muniInformador":571,"departamentoInformador":8,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\549937424.pdf"},{"id":1344,"correoUsuario":"max.jimenez502@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Maximiliano Misael Jiménez Andrés","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":113,"municipio":"San Rafael La Independencia","deptoCreador":0,"muniInformador":572,"departamentoInformador":8,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\934375300.pdf"},{"id":1345,"correoUsuario":"anibalbenamarperez@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Anibal Benamar Pérez Matias","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":123,"municipio":"Todos Santos Cuchumatán","deptoCreador":0,"muniInformador":573,"departamentoInformador":8,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\464154052.pdf"},{"id":1346,"correoUsuario":"ducjime@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Jaime Sales Andrés","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":107,"municipio":"San Juan Atitán","deptoCreador":0,"muniInformador":574,"departamentoInformador":8,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\255470835.pdf"},{"id":1347,"correoUsuario":"daviddiegomarcos91@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"David Diego Marcos","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":120,"municipio":"Santa Eulalia","deptoCreador":0,"muniInformador":575,"departamentoInformador":8,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\4985810.pdf"},{"id":1348,"correoUsuario":"sergiovg-86@hotmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Sergio Valentin Godinez Perez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":109,"municipio":"San Mateo Ixtatán","deptoCreador":0,"muniInformador":576,"departamentoInformador":8,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\673664087.pdf"},{"id":1349,"correoUsuario":"henryveltory@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Henry Dagoberto Velásquez Ortiz","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":94,"municipio":"Colotenango","deptoCreador":0,"muniInformador":577,"departamentoInformador":8,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\184150646.pdf"},{"id":1350,"correoUsuario":"rudygodinez915@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Rudy Martín Hernández Godínez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":116,"municipio":"San Sebastián Huehuetenango","deptoCreador":0,"muniInformador":578,"departamentoInformador":8,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\603546099.pdf"},{"id":1351,"correoUsuario":"mjosuemarcos5@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Joél Marcos Morales Pérez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":122,"municipio":"Tectitán","deptoCreador":0,"muniInformador":579,"departamentoInformador":8,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\304181271.pdf"},{"id":1352,"correoUsuario":"camposecoguadalupe031@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Gricelda Guadalupe Quiñonez Camposeco","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":95,"municipio":"Concepción Huista","deptoCreador":0,"muniInformador":580,"departamentoInformador":8,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1261520866.pdf"},{"id":1353,"correoUsuario":"munisanixcoyh@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Sergio Alexander García Aguilar","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":108,"municipio":"San Juan Ixcoy","deptoCreador":0,"muniInformador":581,"departamentoInformador":8,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\2067658536.pdf"},{"id":1354,"correoUsuario":"uaipsanantoniohuista24@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Yiselth Claralucia Velásquez Mateo","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":104,"municipio":"San Antonio Huista","deptoCreador":0,"muniInformador":582,"departamentoInformador":8,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1525072429.pdf"},{"id":1355,"correoUsuario":"diegogas13091991@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Diego Gaspar Diego","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":115,"municipio":"San Sebastián Coatán","deptoCreador":0,"muniInformador":583,"departamentoInformador":8,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1465447568.pdf"},{"id":1356,"correoUsuario":"gloriscardonaavila@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Glorys Beverly Cardona Avila","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":119,"municipio":"Santa Cruz Barillas","deptoCreador":0,"muniInformador":584,"departamentoInformador":8,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\520626797.pdf"},{"id":1357,"correoUsuario":"munideaguacatan@hotmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Emilio Lux Castro","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":92,"municipio":"Aguacatán","deptoCreador":0,"muniInformador":585,"departamentoInformador":8,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\779449488.pdf"},{"id":1358,"correoUsuario":"jaston.perez28@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Jaston Ronaldo Pérez Sales","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":114,"municipio":"San Rafael Pétzal","deptoCreador":0,"muniInformador":586,"departamentoInformador":8,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\121815452.pdf"},{"id":1359,"correoUsuario":"accesopublicasangasparixchil@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Senaida Patricia Godínez Pérez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":105,"municipio":"San Gaspar Ixchil","deptoCreador":0,"muniInformador":587,"departamentoInformador":8,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1350208163.pdf"},{"id":1360,"correoUsuario":"moralesrobertocarlos2410@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Roberto Carlos Morales García","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":121,"municipio":"Santiago Chimaltenango","deptoCreador":0,"muniInformador":588,"departamentoInformador":8,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\2019917170.pdf"},{"id":1361,"correoUsuario":"munisantaana1@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Randi Jordani Peláez Armas","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":117,"municipio":"Santa Ana Huista","deptoCreador":0,"muniInformador":589,"departamentoInformador":8,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\836230373.pdf"},{"id":1362,"correoUsuario":"municipalidad1332@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Doris Adeisy López Funes","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":124,"municipio":"Unión Cantinil","deptoCreador":0,"muniInformador":590,"departamentoInformador":8,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1976107956.pdf"},{"id":1363,"correoUsuario":"unidadinfopublica1@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Ricardo Alexander Domingo Hernández","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":103,"municipio":"Petatán","deptoCreador":0,"muniInformador":591,"departamentoInformador":8,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\216128784.pdf"},{"id":1364,"correoUsuario":"sacatepequez@amiguate.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Sacatepequez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":344,"municipio":"Ficti 3","deptoCreador":0,"muniInformador":592,"departamentoInformador":23,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1369095234.pdf"},{"id":1365,"correoUsuario":"chimaltenango@amiguate.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Chimaltenango","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":345,"municipio":"Ficti 4","deptoCreador":0,"muniInformador":593,"departamentoInformador":23,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\942031589.pdf"},{"id":1366,"correoUsuario":"escuintla@amiguate.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Escuintla","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":346,"municipio":"Ficti 5","deptoCreador":0,"muniInformador":594,"departamentoInformador":23,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1374122088.pdf"},{"id":1367,"correoUsuario":"santarosa@amiguate.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Santa Rosa","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":347,"municipio":"Ficti 6","deptoCreador":0,"muniInformador":595,"departamentoInformador":23,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1043931357.pdf"},{"id":1368,"correoUsuario":"solola@amiguate.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Solola","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":348,"municipio":"Ficti 7","deptoCreador":0,"muniInformador":596,"departamentoInformador":23,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1708092937.pdf"},{"id":1369,"correoUsuario":"bajaverapaz@amiguate.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Baja Verapaz","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":356,"municipio":"Ficti 15","deptoCreador":0,"muniInformador":597,"departamentoInformador":23,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1680300523.pdf"},{"id":1370,"correoUsuario":"altaverapaz@amiguate.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Alta Verapaz","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":357,"municipio":"Ficti 16","deptoCreador":0,"muniInformador":598,"departamentoInformador":23,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\2081602984.pdf"},{"id":1371,"correoUsuario":"suchitepequez@amiguate.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Suchitepequez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":351,"municipio":"Ficti 10","deptoCreador":0,"muniInformador":599,"departamentoInformador":23,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1147651271.pdf"},{"id":1372,"correoUsuario":"totonicapan@amiguate.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Totonicapan","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":349,"municipio":"Ficti 8","deptoCreador":0,"muniInformador":600,"departamentoInformador":23,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1392393944.pdf"},{"id":1373,"correoUsuario":"quetzaltenango@amiguate.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Quetzaltengo","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":350,"municipio":"Ficti 9","deptoCreador":0,"muniInformador":601,"departamentoInformador":23,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1301702552.pdf"},{"id":1374,"correoUsuario":"retalhuleu@amiguate.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Retalhuleu","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":352,"municipio":"Ficti 11","deptoCreador":0,"muniInformador":602,"departamentoInformador":23,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1037831554.pdf"},{"id":1375,"correoUsuario":"sanmarcos@amiguate.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"San Marcos","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":353,"municipio":"Ficti 12","deptoCreador":0,"muniInformador":603,"departamentoInformador":23,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1974802641.pdf"},{"id":1376,"correoUsuario":"huehuetenango@amiguate.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Huehuetenango","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":354,"municipio":"Ficti 13","deptoCreador":0,"muniInformador":604,"departamentoInformador":23,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\371921777.pdf"},{"id":1377,"correoUsuario":"aeramirez@muniantigua.gob.gt","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Ángel Estuardo Ramírez de León","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":225,"municipio":"Antigua Guatemala","deptoCreador":0,"muniInformador":605,"departamentoInformador":16,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1593867862.pdf"},{"id":1378,"correoUsuario":"jefepersonal@munimorales.gob.gt","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Carlos Lei Hong Sen Chacón","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":128,"municipio":"Morales","deptoCreador":0,"muniInformador":606,"departamentoInformador":9,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\887919977.pdf"},{"id":1379,"correoUsuario":"dmp@munipuertobarrios.gob.gt","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Marco Polo Coronado Castañeda","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":129,"municipio":"Puerto Barrios","deptoCreador":0,"muniInformador":607,"departamentoInformador":9,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1638725438.pdf"},{"id":1380,"correoUsuario":"elincarrillo1996@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Elin Alonzo Carrillo Ramírez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":127,"municipio":"Los Amates","deptoCreador":0,"muniInformador":608,"departamentoInformador":9,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\438823063.pdf"},{"id":1381,"correoUsuario":"quiche@amiguate.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Quiche","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":355,"municipio":"Ficti 14","deptoCreador":0,"muniInformador":609,"departamentoInformador":23,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\277062641.pdf"},{"id":1382,"correoUsuario":"kokingonzalezr@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Cristofer Aroldo González Roca","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":126,"municipio":"Livingston","deptoCreador":0,"muniInformador":610,"departamentoInformador":9,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\565067180.pdf"},{"id":1383,"correoUsuario":"secretariaelestor@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Delia Marisela Maquin Cucul","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":125,"municipio":"El Estor","deptoCreador":0,"muniInformador":611,"departamentoInformador":9,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\952177267.pdf"},{"id":1384,"correoUsuario":"peten@amiguate.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Peten","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":358,"municipio":"Ficti 17","deptoCreador":0,"muniInformador":612,"departamentoInformador":23,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1281784295.pdf"},{"id":1385,"correoUsuario":"izabal@amiguate.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Izabal","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":359,"municipio":"Ficti 18","deptoCreador":0,"muniInformador":613,"departamentoInformador":23,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\140376880.pdf"},{"id":1386,"correoUsuario":"zacapa@amiguate.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Zacapa","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":360,"municipio":"Ficti 19","deptoCreador":0,"muniInformador":614,"departamentoInformador":23,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1045396483.pdf"},{"id":1387,"correoUsuario":"chiquimula@amiguate.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Chiquimula","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":361,"municipio":"Ficti 20","deptoCreador":0,"muniInformador":615,"departamentoInformador":23,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\142116503.pdf"},{"id":1388,"correoUsuario":"jalapa@amiguate.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Jalapa","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":362,"municipio":"Ficti 21","deptoCreador":0,"muniInformador":616,"departamentoInformador":23,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\943083830.pdf"},{"id":1389,"correoUsuario":"leilacorado@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Ana Leila Corado Rodríguez ","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":27,"municipio":"Chimaltenango","deptoCreador":0,"muniInformador":617,"departamentoInformador":3,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\2025685352.pdf"},{"id":1390,"correoUsuario":"jutiapa@amiguate.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Jutiapa","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":363,"municipio":"Ficti 22","deptoCreador":0,"muniInformador":618,"departamentoInformador":23,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1682894393.pdf"},{"id":1391,"correoUsuario":"tepazcolbert2009@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Colbert Albano Tepaz Ailón","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":37,"municipio":"Santa Apolonia","deptoCreador":0,"muniInformador":619,"departamentoInformador":3,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\435141885.pdf"},{"id":1392,"correoUsuario":"secretariamunicipaljoc@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Héctor Alfredo Tomás Coy","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":224,"municipio":"Jocotenango","deptoCreador":0,"muniInformador":620,"departamentoInformador":16,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1796797042.pdf"},{"id":1393,"correoUsuario":"gonzalezelder02@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Elder Adán González Godínez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":227,"municipio":"Pastores","deptoCreador":0,"muniInformador":621,"departamentoInformador":16,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1091506429.pdf"},{"id":1394,"correoUsuario":"edgardaniloherrera@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Edgar Danilo Herrera Cifuentes","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":96,"municipio":"Cuilco","deptoCreador":0,"muniInformador":622,"departamentoInformador":8,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1622678928.pdf"},{"id":1395,"correoUsuario":"ulaipmunisantiagosac2024@yahoo.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Victor Hugo Yac Quel","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":235,"municipio":"Santiago Sacatepéquez","deptoCreador":0,"muniInformador":623,"departamentoInformador":16,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1263504488.pdf"},{"id":1396,"correoUsuario":"evelyn.889@hotmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Evelyn Janeth Anona Chunchún ","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":237,"municipio":"Sumpango","deptoCreador":0,"muniInformador":624,"departamentoInformador":16,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\993904018.pdf"},{"id":1397,"correoUsuario":"informacionpublica@munisanbartolome.gob.gt","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Lesbia Maritza Castillo Toledo","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":229,"municipio":"San Bartolomé Milpas Altas","deptoCreador":0,"muniInformador":625,"departamentoInformador":16,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\991031264.pdf"},{"id":1398,"correoUsuario":"proyectosdmp@munisanlucas.gob.gt","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Karla  Gomez Vargas","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":230,"municipio":"San Lucas Sacatepéquez","deptoCreador":0,"muniInformador":626,"departamentoInformador":16,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1777576342.pdf"},{"id":1399,"correoUsuario":"direcciondmp@munisantaluciama.gob.gt","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Melvin Gudiel Valle Dondiego","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":233,"municipio":"Santa Lucía Milpas Altas","deptoCreador":0,"muniInformador":627,"departamentoInformador":16,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1876607664.PDF"},{"id":1400,"correoUsuario":"danielpetetsalome@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Ronald Daniel Petet Salomé","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":234,"municipio":"Santa María de Jesús","deptoCreador":0,"muniInformador":628,"departamentoInformador":16,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\186353206.pdf"},{"id":1401,"correoUsuario":"municipalidad@municiudadvieja.gob.gt","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Cristians Roselia Hernández Gómez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":223,"municipio":"Ciudad Vieja","deptoCreador":0,"muniInformador":629,"departamentoInformador":16,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1774455816.pdf"},{"id":1402,"correoUsuario":"sanmiguelduenasmunicipalidad@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Paola Lisbeth González Lopez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":231,"municipio":"San Miguel Dueñas","deptoCreador":0,"muniInformador":630,"departamentoInformador":16,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\2005370042.pdf"},{"id":1403,"correoUsuario":"eferonald94@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Ronald Fernando Marroquín Pamal","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":222,"municipio":"Alotenango","deptoCreador":0,"muniInformador":631,"departamentoInformador":16,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1278293645.pdf"},{"id":1404,"correoUsuario":"secremunisanantonio2024@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Francisca del Rosario Apen López","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":228,"municipio":"San Antonio Aguas Calientes","deptoCreador":0,"muniInformador":632,"departamentoInformador":16,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1428246529.PDF"},{"id":1405,"correoUsuario":"silviakarinaos@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Silvia Karina Ordóñez Subuyuj","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":232,"municipio":"Santa Catarina Barahona","deptoCreador":0,"muniInformador":633,"departamentoInformador":16,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\985120372.pdf"},{"id":1406,"correoUsuario":"gestionmalacatancito@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Kleiry Minelly Alvarado Hidalgo","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":101,"municipio":"Malacatancito","deptoCreador":0,"muniInformador":634,"departamentoInformador":8,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1637156236.pdf"},{"id":1407,"correoUsuario":"avimael.juan10@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Anderson Abimael Juan Baltazar","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":102,"municipio":"Nentón","deptoCreador":0,"muniInformador":635,"departamentoInformador":8,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1502234069.pdf"},{"id":1408,"correoUsuario":"marcomaldonado8@yahoo.es","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Marco Augusto Maldonado Mérida","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":118,"municipio":"Santa Bárbara","deptoCreador":0,"muniInformador":636,"departamentoInformador":8,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\212938217.pdf"},{"id":1409,"correoUsuario":"christophercuculista@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Christopher Alexander Dubon Cuculista","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":216,"municipio":"Retalhuleu","deptoCreador":0,"muniInformador":637,"departamentoInformador":15,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1704694641.pdf"},{"id":1410,"correoUsuario":"ssharonmelisa@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Sharon Melisa Solano Ramírez de Ramírez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":221,"municipio":"Santa Cruz Muluá","deptoCreador":0,"muniInformador":638,"departamentoInformador":15,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\2132756575.pdf"},{"id":1411,"correoUsuario":"deleonivan1997@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Dorian Ivan de León","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":219,"municipio":"San Martín Zapotitlán","deptoCreador":0,"muniInformador":639,"departamentoInformador":15,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1748230884.pdf"},{"id":1412,"correoUsuario":"smafer055@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"María Fernanda López Santiago","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":218,"municipio":"San Felipe","deptoCreador":0,"muniInformador":640,"departamentoInformador":15,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\389057331.pdf"},{"id":1413,"correoUsuario":"maryovani@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Marvin Yovani Espinoza Cifuentes","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":217,"municipio":"San Andrés Villa Seca","deptoCreador":0,"muniInformador":641,"departamentoInformador":15,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\762270711.pdf"},{"id":1414,"correoUsuario":"velasquezligia11@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Ligia Gabriela Velásquez Aj","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":213,"municipio":"Champerico","deptoCreador":0,"muniInformador":642,"departamentoInformador":15,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\370495244.pdf"},{"id":1415,"correoUsuario":"rrhhmuninsc@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Mitzie Yanira López Reyes","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":215,"municipio":"Nuevo San Carlos","deptoCreador":0,"muniInformador":643,"departamentoInformador":15,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\559519630.pdf"},{"id":1416,"correoUsuario":"maresrene80@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Mario Renes Estrada Vásquez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":214,"municipio":"El Asintal","deptoCreador":0,"muniInformador":644,"departamentoInformador":15,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1664945751.pdf"},{"id":1417,"correoUsuario":"accesoalainfolalibertad@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Yimmy Alam Cardona Martinez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":100,"municipio":"La Libertad","deptoCreador":0,"muniInformador":645,"departamentoInformador":8,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1648388823.pdf"},{"id":1418,"correoUsuario":"alberto.orellana01@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Jesus Alberto Orellana Pérez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":19,"municipio":"Granados","deptoCreador":0,"muniInformador":646,"departamentoInformador":2,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\527047490.pdf"},{"id":1419,"correoUsuario":"ildergarrido@gmail.com","estadosId":2,"estado":"Inactivo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Ilder Antonio Garrido García","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":25,"municipio":"Santa Cruz el Chol","deptoCreador":0,"muniInformador":647,"departamentoInformador":2,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1828126835.pdf"},{"id":1420,"correoUsuario":"cahuecjuliana@gmail.com","estadosId":2,"estado":"Inactivo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Julia Cahuec López","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":21,"municipio":"Rabinal","deptoCreador":0,"muniInformador":648,"departamentoInformador":2,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1225365770.pdf"},{"id":1421,"correoUsuario":"devora.17589@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Devora Eunice Bautista Sanan","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":319,"municipio":"Santo Domingo Suchitepéquez","deptoCreador":0,"muniInformador":649,"departamentoInformador":20,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\114560107.pdf"},{"id":1422,"correoUsuario":"municipalidadsantabarbarasuch@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Cédric Gabriel Duarte Melgar","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":318,"municipio":"Santa Bárbara","deptoCreador":0,"muniInformador":650,"departamentoInformador":20,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1949760606.pdf"},{"id":1423,"correoUsuario":"ang11dlg@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"María de los Ángeles De León García","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":320,"municipio":"Santo Tomás La Unión","deptoCreador":0,"muniInformador":651,"departamentoInformador":20,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\2052739794.pdf"},{"id":1424,"correoUsuario":"ajcalonirene99@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Irene Ajcalón Samines","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":314,"municipio":"San Juan Bautista","deptoCreador":0,"muniInformador":652,"departamentoInformador":20,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\491553765.pdf"},{"id":1425,"correoUsuario":"arlinvelasquez1998@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Arlin Melina Equilá Velasquez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":321,"municipio":"Zunilito","deptoCreador":0,"muniInformador":653,"departamentoInformador":20,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\659050985.pdf"},{"id":1426,"correoUsuario":"csocial203.munixela@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Claudia Elizabeth Aguilar Ixcot","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":182,"municipio":"Quetzaltenango","deptoCreador":0,"muniInformador":654,"departamentoInformador":13,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\2000317366.pdf"},{"id":1427,"correoUsuario":"pablosoch.salcaja.gob.gt@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Pablo Rolando Soch Ixtabalán","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":183,"municipio":"Salcajá","deptoCreador":0,"muniInformador":655,"departamentoInformador":13,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1933846734.pdf"},{"id":1428,"correoUsuario":"jonatanalvarado094@yahoo.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Jonatan Alexander Alvarado Ixchel","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":180,"municipio":"Olintepeque","deptoCreador":0,"muniInformador":656,"departamentoInformador":13,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1924119440.pdf"},{"id":1429,"correoUsuario":"william.maldonado1989@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"William Odanit Maldonado Diaz","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":184,"municipio":"San Carlos Sija","deptoCreador":0,"muniInformador":657,"departamentoInformador":13,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\449437745.pdf"},{"id":1430,"correoUsuario":"ochoagelvermunicipalidad@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Lucia Betzabeth Pojoy Corzo","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":190,"municipio":"Sibilia","deptoCreador":0,"muniInformador":658,"departamentoInformador":13,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\954145614.pdf"},{"id":1431,"correoUsuario":"2014danyperez@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Dany Roberto Edelfo Sales Pérez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":169,"municipio":"Cabricán","deptoCreador":0,"muniInformador":659,"departamentoInformador":13,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1458273317.pdf"},{"id":1432,"correoUsuario":"rabocse22@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Onésimo Escobar méndez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":174,"municipio":"Concepción Chiquirichapa","deptoCreador":0,"muniInformador":660,"departamentoInformador":13,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\2119919273.pdf"},{"id":1433,"correoUsuario":"lisardodeleon44@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Osber Lisardo García de León","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":187,"municipio":"San Martín Sacatepéquez","deptoCreador":0,"muniInformador":661,"departamentoInformador":13,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1538555350.pdf"},{"id":1434,"correoUsuario":"Munialmolonga2024.2028@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Kevin Jhonatan Sánchez Sánchez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":168,"municipio":"Almolonga","deptoCreador":0,"muniInformador":662,"departamentoInformador":13,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1093586461.pdf"},{"id":1435,"correoUsuario":"selvynro@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Selvyn Manolo Reyes Orozco","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":191,"municipio":"Zunil","deptoCreador":0,"muniInformador":663,"departamentoInformador":13,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\619221386.pdf"},{"id":1436,"correoUsuario":"informacionpublica.dcom@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Eric Alfredo gonzález Paxtor","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":185,"municipio":"San Francisco La Unión","deptoCreador":0,"muniInformador":664,"departamentoInformador":13,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\836298705.pdf"},{"id":1437,"correoUsuario":"akathelin363@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Kathelin Elizabeth Arreaga Hernández","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":175,"municipio":"El Palmar","deptoCreador":0,"muniInformador":665,"departamentoInformador":13,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\938635901.pdf"},{"id":1438,"correoUsuario":"sdanilopez@aol.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Sergio Danilo López Calderón","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":172,"municipio":"Coatepeque","deptoCreador":0,"muniInformador":666,"departamentoInformador":13,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\2142343660.pdf"},{"id":1439,"correoUsuario":"mackcalmo87@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Omri Magdiel Calmo Escobar","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":177,"municipio":"Génova","deptoCreador":0,"muniInformador":667,"departamentoInformador":13,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1032391059.pdf"},{"id":1440,"correoUsuario":"adriagdl11@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Adriana Lucrecia García de León","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":176,"municipio":"Flores Costa Cuca","deptoCreador":0,"muniInformador":668,"departamentoInformador":13,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\29981973.pdf"},{"id":1441,"correoUsuario":"noegramajo50@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Noe Yanluin Gramajo Rodas","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":220,"municipio":"San Sebastián","deptoCreador":0,"muniInformador":669,"departamentoInformador":15,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1688564616.pdf"},{"id":1442,"correoUsuario":"munidepana@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"elizabeth.palax","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":284,"municipio":"Panajachel","deptoCreador":0,"muniInformador":670,"departamentoInformador":19,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1452834276.pdf"},{"id":1443,"correoUsuario":"17007660@galileo.edu","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"salvador.ixbalan","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":299,"municipio":"Santiago Atitlán","deptoCreador":0,"muniInformador":671,"departamentoInformador":19,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1643324888.pdf"},{"id":1444,"correoUsuario":"marycoz0194@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"olga.coz","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":292,"municipio":"San Pedro La Laguna","deptoCreador":0,"muniInformador":672,"departamentoInformador":19,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\907426132.pdf"},{"id":1445,"correoUsuario":"polivasank19807@gmail.com","estadosId":2,"estado":"Inactivo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Sandra Karolina Pérez Oliva","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":162,"municipio":"San Benito","deptoCreador":0,"muniInformador":673,"departamentoInformador":12,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1024353566.pdf"},{"id":1446,"correoUsuario":"uaip.munisanfranciscopeten@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Kiener Francisco Maldonado Zamora","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":163,"municipio":"San Francisco","deptoCreador":0,"muniInformador":674,"departamentoInformador":12,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1146547436.pdf"},{"id":1447,"correoUsuario":"planificaciondolorespeten@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Nery Estuardo Corzo Acté ","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":154,"municipio":"Dolores","deptoCreador":0,"muniInformador":675,"departamentoInformador":12,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\380013081.pdf"},{"id":1448,"correoUsuario":"josenavarijo@gmial.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Jose Antonio Navarijo López","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":167,"municipio":"Sayaxché","deptoCreador":0,"muniInformador":676,"departamentoInformador":12,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\950221883.pdf"},{"id":1449,"correoUsuario":"coc.carlosarmando@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Carlos Armando Coc Pinelo","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":159,"municipio":"Melchor de Mencos","deptoCreador":0,"muniInformador":677,"departamentoInformador":12,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\939171589.pdf"},{"id":1450,"correoUsuario":"castillokerlin43@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Kerlin Magali Castillo Mazariegos","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":158,"municipio":"Las Cruces","deptoCreador":0,"muniInformador":678,"departamentoInformador":12,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1225303937.pdf"},{"id":1451,"correoUsuario":"violealvarez1@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Violeta Argentina Alvarez García","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":301,"municipio":"Chicacao","deptoCreador":0,"muniInformador":679,"departamentoInformador":20,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\911501509.pdf"},{"id":1452,"correoUsuario":"soporteaccesoinfomunisanber@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Jonathan Antonio Cantor Moran","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":309,"municipio":"San Bernardino","deptoCreador":0,"muniInformador":680,"departamentoInformador":20,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1814769274.pdf"},{"id":1453,"correoUsuario":"morales.asya91@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Astrid Yashodara Morales Morales","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":156,"municipio":"Flores","deptoCreador":0,"muniInformador":681,"departamentoInformador":12,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\582576921.PDF"},{"id":1454,"correoUsuario":"secretariasanpabloj@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Jennifer Lisseth Pelicó Alemán","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":317,"municipio":"San Pablo Jocopilas","deptoCreador":0,"muniInformador":682,"departamentoInformador":20,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\407974230.pdf"},{"id":1455,"correoUsuario":"marineschanta@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Darian Marines Ajquichi Chanta","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":226,"municipio":"Magdalena Milpas Altas","deptoCreador":0,"muniInformador":683,"departamentoInformador":16,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1931903485.pdf"},{"id":1456,"correoUsuario":"lmjreyesp05@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Lorena María José Reyes Paniagua","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":304,"municipio":"Patulul","deptoCreador":0,"muniInformador":684,"departamentoInformador":20,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\575885087.pdf"},{"id":1464,"correoUsuario":"yesky25@hotmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Lourdes Yesenia Ajpop Escum","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":329,"municipio":"Totonicapán","deptoCreador":0,"muniInformador":685,"departamentoInformador":21,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\466440623.pdf"},{"id":1465,"correoUsuario":"rosariocanizsapon@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"María del Rosario Cániz Sapón","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":325,"municipio":"San Cristóbal Totonicapán","deptoCreador":0,"muniInformador":686,"departamentoInformador":21,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\883947158.pdf"},{"id":1466,"correoUsuario":"carlosgmv.1003@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Carlos Gilberto Monroy Vicente","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":323,"municipio":"San Andrés Xecul","deptoCreador":0,"muniInformador":687,"departamentoInformador":21,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1520876214.pdf"},{"id":1467,"correoUsuario":"cuyuchnereyda2@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Jaqueline Nereyda Barrera Cuyuch","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":322,"municipio":"Momostenango","deptoCreador":0,"muniInformador":688,"departamentoInformador":21,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1921114853.pdf"},{"id":1468,"correoUsuario":"antoniapu3116@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Antonia Gricelda Pú Ixcoteyac","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":328,"municipio":"Santa María Chiquimula","deptoCreador":0,"muniInformador":689,"departamentoInformador":21,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\2062582606.pdf"},{"id":1469,"correoUsuario":"municipalidaduipsantalucialare@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Suarlin Damián Chivalán Castro","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":327,"municipio":"Santa Lucía La Reforma","deptoCreador":0,"muniInformador":690,"departamentoInformador":21,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\64419354.pdf"},{"id":1470,"correoUsuario":"angelachampet8@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Angela Eunice Champet Pérez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":324,"municipio":"San Bartolo","deptoCreador":0,"muniInformador":691,"departamentoInformador":21,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\760545174.pdf"},{"id":1471,"correoUsuario":"jsapongarcia@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Juan Abimael Sapón García","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":308,"municipio":"San Antonio Suchitepéquez","deptoCreador":0,"muniInformador":692,"departamentoInformador":20,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\50654603.pdf"},{"id":1472,"correoUsuario":"procesos@municoban.gob.gt.","estadosId":2,"estado":"Inactivo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Juan Carlos López Cruz","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":3,"municipio":"Cobán","deptoCreador":0,"muniInformador":693,"departamentoInformador":1,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\397658210.pdf"},{"id":1473,"correoUsuario":"ovidioottonieljt@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Ovidio Ottoniel Jul Tul","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":12,"municipio":"Santa Cruz Verapaz","deptoCreador":0,"muniInformador":694,"departamentoInformador":1,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\451828492.pdf"},{"id":1474,"correoUsuario":"uipm@munisancristobalverapaz.gob.gt","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Estefani Cristabel Cal Gué","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":9,"municipio":"San Cristóbal Verapaz","deptoCreador":0,"muniInformador":695,"departamentoInformador":1,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1032917445.pdf"},{"id":1475,"correoUsuario":"mmonseq23@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Midamss Yusseli Caal Xoná","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":16,"municipio":"Tactic","deptoCreador":0,"muniInformador":696,"departamentoInformador":1,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1830451874.pdf"},{"id":1476,"correoUsuario":"josiasss14k09@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Josías Benjamín Ac Quej","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":15,"municipio":"Tamahú","deptoCreador":0,"muniInformador":697,"departamentoInformador":1,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1668578411.pdf"},{"id":1477,"correoUsuario":"daniel8mayo@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Daniel Cal Rax","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":17,"municipio":"San Miguel Tucurú","deptoCreador":0,"muniInformador":698,"departamentoInformador":1,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\712879458.pdf"},{"id":1478,"correoUsuario":"marfany01@hotmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Marlee Fanny Suzzeth Botzoc ","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":7,"municipio":"Panzós","deptoCreador":0,"muniInformador":699,"departamentoInformador":1,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1204893915.pdf"},{"id":1479,"correoUsuario":"caalbarrientoshugo@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Hugo Samuel Caal Barrientos","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":14,"municipio":"Senahú","deptoCreador":0,"muniInformador":700,"departamentoInformador":1,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\538379176.pdf"},{"id":1480,"correoUsuario":"nerypinula25@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Julio Nery Esteban Pinula Martinez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":11,"municipio":"San Pedro Carchá","deptoCreador":0,"muniInformador":701,"departamentoInformador":1,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1506104953.pdf"},{"id":1481,"correoUsuario":"uipm@munichamelco.gob.gt","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Jesmy Abigail Sierra Fernández","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":10,"municipio":"San Juan Chamelco","deptoCreador":0,"muniInformador":702,"departamentoInformador":1,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1680184296.pdf"},{"id":1482,"correoUsuario":"uipm@munilanquin.gob.gt","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Darwin Emanuel Caal Yaxcal","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":6,"municipio":"San Agustín Lanquín","deptoCreador":0,"muniInformador":703,"departamentoInformador":1,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\2063199849.pdf"},{"id":1483,"correoUsuario":"aryaxcal@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Arnoldo Yaxcal Cuz","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":13,"municipio":"Santa María Cahabón","deptoCreador":0,"muniInformador":704,"departamentoInformador":1,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\30256800.pdf"},{"id":1484,"correoUsuario":"caalsierranelson@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Nelson Alexander Caal Sierra","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":2,"municipio":"Chisec","deptoCreador":0,"muniInformador":705,"departamentoInformador":1,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\2047562257.pdf"},{"id":1485,"correoUsuario":"informacionpublica@munichahal.gob.gt","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Elsy Magdalis Caal Choc","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":1,"municipio":"Chahal","deptoCreador":0,"muniInformador":706,"departamentoInformador":1,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\226702597.pdf"},{"id":1486,"correoUsuario":"tumunifray@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Pedro Augusto Soria Reyes","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":4,"municipio":"Fray Bartolomé de las Casas","deptoCreador":0,"muniInformador":707,"departamentoInformador":1,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1253143769.pdf"},{"id":1487,"correoUsuario":"tigrecabnal@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Francisco Misael Cabnal Pereira","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":5,"municipio":"Santa Catarina La Tinta","deptoCreador":0,"muniInformador":708,"departamentoInformador":1,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\2058295286.pdf"},{"id":1488,"correoUsuario":"daberlincornelio1@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Daverlin Jessenia Cornelio Hernandez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":8,"municipio":"Raxruhá","deptoCreador":0,"muniInformador":709,"departamentoInformador":1,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1442833679.pdf"},{"id":1489,"correoUsuario":"uaipsanjose@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"César David Mancilla Manchame","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":164,"municipio":"San José","deptoCreador":0,"muniInformador":710,"departamentoInformador":12,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\334242676.PDF"},{"id":1490,"correoUsuario":"carlosacostasolis@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Carlos Wilfredo Acosta Solis","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":161,"municipio":"San Andrés","deptoCreador":0,"muniInformador":711,"departamentoInformador":12,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1630764377.pdf"},{"id":1491,"correoUsuario":"jesabelorregomendez@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Adriana Jesabel Orrego Méndez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":157,"municipio":"La Libertad","deptoCreador":0,"muniInformador":712,"departamentoInformador":12,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\964078222.pdf"},{"id":1492,"correoUsuario":"franklynalexandergarcia@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Franklyn Humberto Alexander Cortez García","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":165,"municipio":"San Luis","deptoCreador":0,"muniInformador":713,"departamentoInformador":12,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\453683002.pdf"},{"id":1493,"correoUsuario":"planificacionpoptun@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Deyci Eugenia Najarro Barrera","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":160,"municipio":"Poptún","deptoCreador":0,"muniInformador":714,"departamentoInformador":12,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1239391467.pdf"},{"id":1494,"correoUsuario":"randyestrada62@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Randy Abilio Estrada Estrada","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":155,"municipio":"El Chal","deptoCreador":0,"muniInformador":715,"departamentoInformador":12,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\877837119.pdf"},{"id":1495,"correoUsuario":"anibaleduar2014@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Anibal Eduardo Azañon Mis","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":166,"municipio":"Santa Ana","deptoCreador":0,"muniInformador":716,"departamentoInformador":12,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1266512829.pdf"},{"id":1496,"correoUsuario":"josenavarijo@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Jose Antonio Navarijo López","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":167,"municipio":"Sayaxché","deptoCreador":0,"muniInformador":717,"departamentoInformador":12,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1125888725.pdf"},{"id":1497,"correoUsuario":"reyeskenet140@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Kénet Geovany Reyes Calvillo","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":25,"municipio":"Santa Cruz el Chol","deptoCreador":0,"muniInformador":718,"departamentoInformador":2,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1185274392.pdf"},{"id":1498,"correoUsuario":"yeisonvaley5@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Yeison Ulicer Valey Sical","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":21,"municipio":"Rabinal","deptoCreador":0,"muniInformador":719,"departamentoInformador":2,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1578212178.pdf"},{"id":1499,"correoUsuario":"rrhh@municuilapa.gob.gt","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Gemina Abigail Gomez Perez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":271,"municipio":"Cuilapa","deptoCreador":0,"muniInformador":720,"departamentoInformador":18,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\789489906.pdf"},{"id":1500,"correoUsuario":"licetpaiz@hotmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Norma Licet Paiz Hernandez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":268,"municipio":"Barberena","deptoCreador":0,"muniInformador":721,"departamentoInformador":18,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1040272100.pdf"},{"id":1501,"correoUsuario":"infomunisrl@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Ericka Mercedes Alejandra Acevédo Recinos","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":280,"municipio":"Santa Rosa de Lima","deptoCreador":0,"muniInformador":722,"departamentoInformador":18,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\321953442.pdf"},{"id":1502,"correoUsuario":"danielaherreraa48@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Claudia Estefani Daniela Herrera Aguilar","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":269,"municipio":"Casillas","deptoCreador":0,"muniInformador":723,"departamentoInformador":18,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1812844628.pdf"},{"id":1503,"correoUsuario":"gabiedithosoriojuarez@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Gabriela Edith Osorio Juárez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":277,"municipio":"San Rafael las Flores","deptoCreador":0,"muniInformador":724,"departamentoInformador":18,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1813261373.pdf"},{"id":1504,"correoUsuario":"infomunioratorio1993@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Arlyn Ninette Jiménez Franco","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":274,"municipio":"Oratorio","deptoCreador":0,"muniInformador":725,"departamentoInformador":18,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1548780181.pdf"},{"id":1505,"correoUsuario":"recursoshumanos@tumunisanjuantecuaco.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Soel Gustavo Juárez Cabrera","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":276,"municipio":"San Juan Tecuaco","deptoCreador":0,"muniInformador":726,"departamentoInformador":18,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1982876823.pdf"},{"id":1506,"correoUsuario":"melgarlester121@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Lester Ramiro Melgar Mijangos","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":270,"municipio":"Chiquimulilla","deptoCreador":0,"muniInformador":727,"departamentoInformador":18,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1429614896.pdf"},{"id":1507,"correoUsuario":"delosangelesaguirre60@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Marisol de los Ángeles Aguirre Mendoza","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":281,"municipio":"Taxisco","deptoCreador":0,"muniInformador":728,"departamentoInformador":18,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1201142483.pdf"},{"id":1508,"correoUsuario":"didimolinadavila@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Virginia Didania Molina Dávila","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":279,"municipio":"Santa María Ixhuatán","deptoCreador":0,"muniInformador":729,"departamentoInformador":18,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1992124809.pdf"},{"id":1509,"correoUsuario":"infop@municipalidadguazacapan.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Alba Victoria Roldan Estrada","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":272,"municipio":"Guazacapán","deptoCreador":0,"muniInformador":730,"departamentoInformador":18,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1597277467.PDF"},{"id":1510,"correoUsuario":"uip@munisantacruznaranjo.gob.gt","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Rodvin Alfredo Monterroso Revolorio","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":278,"municipio":"Santa Cruz Naranjo","deptoCreador":0,"muniInformador":731,"departamentoInformador":18,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1621514035.pdf"},{"id":1511,"correoUsuario":"infouaip@munipnv.gob.gt","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Ericka Tatiana Coter Tuche","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":275,"municipio":"Pueblo Nuevo Viñas","deptoCreador":0,"muniInformador":732,"departamentoInformador":18,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\376678659.pdf"},{"id":1512,"correoUsuario":"informacionpublicansr2015@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Sofina Ines Contreras Barrera","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":273,"municipio":"Nueva Santa Rosa","deptoCreador":0,"muniInformador":733,"departamentoInformador":18,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\2036525052.pdf"},{"id":1513,"correoUsuario":"enlace3@amiguate.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Enlace 3","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":351,"municipio":"Ficti 10","deptoCreador":0,"muniInformador":734,"departamentoInformador":23,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1450326752.pdf"},{"id":1514,"correoUsuario":"enlace4@amiguate.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Enlace 4","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":356,"municipio":"Ficti 15","deptoCreador":0,"muniInformador":735,"departamentoInformador":23,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\631476418.pdf"},{"id":1515,"correoUsuario":"enlace5@amiguate.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Enlace 5","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":346,"municipio":"Ficti 5","deptoCreador":0,"muniInformador":736,"departamentoInformador":23,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1224609431.pdf"},{"id":1516,"correoUsuario":"enlace6@amiguate.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Enlace 6","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":358,"municipio":"Ficti 17","deptoCreador":0,"muniInformador":737,"departamentoInformador":23,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\2116291358.pdf"},{"id":1518,"correoUsuario":"enlace7@amiguate.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Enlace 7","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":361,"municipio":"Ficti 20","deptoCreador":0,"muniInformador":738,"departamentoInformador":23,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1433546766.pdf"},{"id":1520,"correoUsuario":"enlace8@amiguate.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Enlace 8","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":359,"municipio":"Ficti 18","deptoCreador":0,"muniInformador":739,"departamentoInformador":23,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1142750880.pdf"},{"id":1521,"correoUsuario":"enlace9@amiguate.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Enlace 9","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":362,"municipio":"Ficti 21","deptoCreador":0,"muniInformador":740,"departamentoInformador":23,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1582029976.pdf"},{"id":1522,"correoUsuario":"enlace10@amiguate.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Enlace 10","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":351,"municipio":"Ficti 10","deptoCreador":0,"muniInformador":741,"departamentoInformador":23,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\744039707.pdf"},{"id":1536,"correoUsuario":"info@munidejutiapa.gob.gt","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Juan Estuardo López Hernández","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":146,"municipio":"Jutiapa","deptoCreador":0,"muniInformador":742,"departamentoInformador":11,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1064152922.pdf"},{"id":1537,"correoUsuario":"naydideguerrero8@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Naydi Rociel Montecinos Carpio","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":143,"municipio":"El Progreso","deptoCreador":0,"muniInformador":743,"departamentoInformador":11,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1606591635.pdf"},{"id":1541,"correoUsuario":"info@munisantacatarinamita.gob.gt","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Francis Mauricio Santos Flores","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":151,"municipio":"Santa Catarina Mita","deptoCreador":0,"muniInformador":744,"departamentoInformador":11,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\670291984.pdf"},{"id":1542,"correoUsuario":"castameliza2014@hotmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Casta Meliza Carpio Escobar","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":137,"municipio":"Agua Blanca","deptoCreador":0,"muniInformador":745,"departamentoInformador":11,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\220608177.pdf"},{"id":1543,"correoUsuario":"ysurama@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Yeni Surama Zuñiga Mansilla","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":236,"municipio":"Santo Domingo Xenacoj","deptoCreador":0,"muniInformador":746,"departamentoInformador":16,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1907285984.pdf"},{"id":1545,"correoUsuario":"fernandogoncortez195@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Fernando Antonio González Cortéz","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":138,"municipio":"Asunción Mita","deptoCreador":0,"muniInformador":747,"departamentoInformador":11,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\407186155.pdf"},{"id":1547,"correoUsuario":"yasmincita19_@hotmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Sindy Yasmina Godoy Ordóñez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":152,"municipio":"Yupiltepeque","deptoCreador":0,"muniInformador":748,"departamentoInformador":11,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\239126427.pdf"},{"id":1548,"correoUsuario":"elizabethgonzalez3435@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Angela Elizabeth Tenas González","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":139,"municipio":"Atescatempa","deptoCreador":0,"muniInformador":749,"departamentoInformador":11,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\43073448.pdf"},{"id":1550,"correoUsuario":"munijerezomp@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Concepción Salazar Linares","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":145,"municipio":"Jerez","deptoCreador":0,"muniInformador":750,"departamentoInformador":11,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\317547271.pdf"},{"id":1552,"correoUsuario":"uipm@munieladelanto.gob.gt","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Oscar Estid Corado Corado","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":142,"municipio":"El Adelanto","deptoCreador":0,"muniInformador":751,"departamentoInformador":11,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1072600442.pdf"},{"id":1554,"correoUsuario":"melviinher@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Melvin Gamaliel Hernández Godoy","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":153,"municipio":"Zapotitlán","deptoCreador":0,"muniInformador":752,"departamentoInformador":11,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\2081364650.pdf"},{"id":1555,"correoUsuario":"micorreosanchez2015@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Diana Gabriela Sánchez López","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":140,"municipio":"Comapa","deptoCreador":0,"muniInformador":753,"departamentoInformador":11,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\509010859.pdf"},{"id":1557,"correoUsuario":"ernestosalvador132@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Ernesto Paulino Salvador Hernández","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":144,"municipio":"Jalpatagua","deptoCreador":0,"muniInformador":754,"departamentoInformador":11,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1822817873.pdf"},{"id":1559,"correoUsuario":"alapublicaconguaco@hotmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Sergio David Cruz","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":141,"municipio":"Conguaco","deptoCreador":0,"muniInformador":755,"departamentoInformador":11,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1185070751.pdf"},{"id":1560,"correoUsuario":"jglucerodelaguila@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"José Guillermo Lucero del Águila","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":147,"municipio":"Moyuta","deptoCreador":0,"muniInformador":756,"departamentoInformador":11,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\36655412.pdf"},{"id":1562,"correoUsuario":"jmarroquinhernandez94@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Juan Carlos Marroquín Hernández","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":148,"municipio":"Pasaco","deptoCreador":0,"muniInformador":757,"departamentoInformador":11,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1703180313.pdf"},{"id":1564,"correoUsuario":"accesoalainformacion2021@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Jaqueline Liseth Herrera Salazar","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":150,"municipio":"San José Acatempa","deptoCreador":0,"muniInformador":758,"departamentoInformador":11,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\184626080.pdf"},{"id":1565,"correoUsuario":"astrygrijalva@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Astry Yulisa Grijalva García","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":149,"municipio":"Quesada","deptoCreador":0,"muniInformador":759,"departamentoInformador":11,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\190326554.pdf"},{"id":1584,"correoUsuario":"rankingdegestionmunicipal@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Sandra Leticia Marroquín Rodríguez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":130,"municipio":"Jalapa","deptoCreador":0,"muniInformador":760,"departamentoInformador":10,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\157936149.pdf"},{"id":1585,"correoUsuario":"jaimegmez12@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Jaime Estuardo Gómez Gómez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":134,"municipio":"San Luis Jilotepeque","deptoCreador":0,"muniInformador":761,"departamentoInformador":10,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1621450810.pdf"},{"id":1586,"correoUsuario":"novayasmin85@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Leticia Yasmin Nova Yaque","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":135,"municipio":"San Manuel Chaparrón","deptoCreador":0,"muniInformador":762,"departamentoInformador":10,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\97095363.pdf"},{"id":1587,"correoUsuario":"gonzalezmarioalexander6@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Mario Alexander Goznalez Najera","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":133,"municipio":"San Carlos Alzatate","deptoCreador":0,"muniInformador":763,"departamentoInformador":10,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1574222879.pdf"},{"id":1588,"correoUsuario":"madelyn1995sandoval@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Madelin Odeth Sandoval Alarcón","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":132,"municipio":"Monjas","deptoCreador":0,"muniInformador":764,"departamentoInformador":10,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1504071435.pdf"},{"id":1589,"correoUsuario":"mataquescuintlamunicipalidad@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Allan Gabriel Aguilar Reyes","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":131,"municipio":"Mataquescuintla","deptoCreador":0,"muniInformador":765,"departamentoInformador":10,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\10658243.pdf"},{"id":1590,"correoUsuario":"roselynester03@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Roselyn Ester González Chanchavac","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":136,"municipio":"San Pedro Pinula","deptoCreador":0,"muniInformador":766,"departamentoInformador":10,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\83431056.pdf"},{"id":1591,"correoUsuario":"siscodeipcsantacruzdelquiche@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Claudia Maribel Tum ","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":210,"municipio":"Santa Cruz del Quiché","deptoCreador":0,"muniInformador":767,"departamentoInformador":14,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1287637604.pdf"},{"id":1592,"correoUsuario":"marisabelchacaj@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Anngely Marisabel Chacaj Calgua","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":197,"municipio":"Chinique","deptoCreador":0,"muniInformador":768,"departamentoInformador":14,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1094549288.pdf"},{"id":1593,"correoUsuario":"riquiacv4939@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"María Verónica Tiu Riquiac ","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":212,"municipio":"Zacualpa","deptoCreador":0,"muniInformador":769,"departamentoInformador":14,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\560925235.pdf"},{"id":1594,"correoUsuario":"info@munichajul.gob.gt","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"María Esperanza Hernandez Ijóm ","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":193,"municipio":"Chajul","deptoCreador":0,"muniInformador":770,"departamentoInformador":14,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\658884565.pdf"},{"id":1595,"correoUsuario":"jorgeajanel4@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Jorge Mario Ajanel González","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":196,"municipio":"Santo Tomás Chichicastenango","deptoCreador":0,"muniInformador":771,"departamentoInformador":14,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1165253794.pdf"},{"id":1596,"correoUsuario":"patzitemunicipalidad@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Francisco Chivalan Leon","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":203,"municipio":"Patzité","deptoCreador":0,"muniInformador":772,"departamentoInformador":14,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\363070289.pdf"},{"id":1597,"correoUsuario":"uipmunisai2026@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"María Paola Simaj Cor","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":206,"municipio":"San Antonio Ilotenango","deptoCreador":0,"muniInformador":773,"departamentoInformador":14,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\83217267.pdf"},{"id":1598,"correoUsuario":"av671470@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Alejandro Antonio Vicente Chavaloc","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":209,"municipio":"San Pedro Jocopilas","deptoCreador":0,"muniInformador":774,"departamentoInformador":14,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1452638002.pdf"},{"id":1599,"correoUsuario":"pinulabotonjuanamargarita@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Juana Margarita Pinula Boton","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":198,"municipio":"Cunén","deptoCreador":0,"muniInformador":775,"departamentoInformador":14,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\16278684.pdf"},{"id":1600,"correoUsuario":"jspcastillo1991@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Carlos Manuel Castillo Rivera","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":208,"municipio":"San Juan Cotzal","deptoCreador":0,"muniInformador":776,"departamentoInformador":14,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\2026020698.pdf"},{"id":1601,"correoUsuario":"informacionpublica@municipalidadjoyabaj.com.gt","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Rosalia Francisca Solval García ","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":200,"municipio":"Joyabaj","deptoCreador":0,"muniInformador":777,"departamentoInformador":14,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1845306510.pdf"},{"id":1602,"correoUsuario":"gerenciamuninebaj2024@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Secundino Antonio Santiago Terraza","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":201,"municipio":"Nebaj","deptoCreador":0,"muniInformador":778,"departamentoInformador":14,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1688840366.pdf"},{"id":1603,"correoUsuario":"auricasjowi@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Rosaura Cosme Cahuec de Ixcuna","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":205,"municipio":"San Andrés Sajcabajá","deptoCreador":0,"muniInformador":779,"departamentoInformador":14,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1152749478.pdf"},{"id":1604,"correoUsuario":"lventurajulio@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Julio Santiago López Ventura","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":211,"municipio":"Uspantán","deptoCreador":0,"muniInformador":780,"departamentoInformador":14,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1584224818.pdf"},{"id":1605,"correoUsuario":"isaiaceytuno04@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Fernando Isaías Aceytuno Palacios","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":204,"municipio":"Sacapulas","deptoCreador":0,"muniInformador":781,"departamentoInformador":14,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1845883616.pdf"},{"id":1606,"correoUsuario":"procesos@municoban.gob.gt","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Juan Carlos López Cruz","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":3,"municipio":"Cobán","deptoCreador":0,"muniInformador":782,"departamentoInformador":1,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\65869999.pdf"},{"id":1607,"correoUsuario":"maon1029@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Martin Adrían Ovalle Natareno","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":207,"municipio":"San Bartolomé Jocotenango","deptoCreador":0,"muniInformador":783,"departamentoInformador":14,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\322319134.pdf"},{"id":1608,"correoUsuario":"glendic2000@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Glendi Mariela Castro Ordoñez ","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":192,"municipio":"Canillá","deptoCreador":0,"muniInformador":784,"departamentoInformador":14,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\2080764707.pdf"},{"id":1609,"correoUsuario":"jvillatoro1980@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Juan Francisco Villatoro Tum ","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":194,"municipio":"Chicamán","deptoCreador":0,"muniInformador":785,"departamentoInformador":14,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1321233956.pdf"},{"id":1610,"correoUsuario":"ortizdeleon1980@yahoo.es","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Natanael Ortiz de León ","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":199,"municipio":"Ixcán","deptoCreador":0,"muniInformador":786,"departamentoInformador":14,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\858954317.pdf"},{"id":1611,"correoUsuario":"germangarcia2916@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"German Eduardo Padilla García","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":202,"municipio":"Pachalum","deptoCreador":0,"muniInformador":787,"departamentoInformador":14,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\722266684.pdf"},{"id":1615,"correoUsuario":"aracelyelu11@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Eluvia Aracely De León Velásquez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":178,"municipio":"Huitán","deptoCreador":0,"muniInformador":788,"departamentoInformador":13,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1147813146.pdf"},{"id":1616,"correoUsuario":"kaibileva16@hotmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Eli Valerio Kaibil Pum Huinac","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":170,"municipio":"Cajolá","deptoCreador":0,"muniInformador":789,"departamentoInformador":13,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\735744333.pdf"},{"id":1617,"correoUsuario":"polivasank1980@gmail.com","estadosId":2,"estado":"Inactivo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Sandra Karolina Pérez Oliva","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":162,"municipio":"San Benito","deptoCreador":0,"muniInformador":790,"departamentoInformador":12,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1292834735.pdf"},{"id":1618,"correoUsuario":"vicentebeatriz372@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Beatriz Vicente Jimenez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":189,"municipio":"San Miguel Sigüilá","deptoCreador":0,"muniInformador":791,"departamentoInformador":13,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\178029096.pdf"},{"id":1619,"correoUsuario":"lopezroberta409@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Roberta Dolores Tecum López","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":311,"municipio":"San Gabriel","deptoCreador":0,"muniInformador":792,"departamentoInformador":20,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1235775662.pdf"},{"id":1620,"correoUsuario":"sanmateomunicipalidad@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Edgar Hermelindo Sánchez Cifuentes","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":188,"municipio":"San Mateo","deptoCreador":0,"muniInformador":793,"departamentoInformador":13,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1462671215.PDF"},{"id":1621,"correoUsuario":"municantelxela@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Edgar Estuardo Morales Ruiz","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":171,"municipio":"Cantel","deptoCreador":0,"muniInformador":794,"departamentoInformador":13,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1172992234.pdf"},{"id":1622,"correoUsuario":"riveradelmy53@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Delmy Aracely Rivera Mazariegos","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":173,"municipio":"Colomba Costa Cuca","deptoCreador":0,"muniInformador":795,"departamentoInformador":13,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\101636620.pdf"},{"id":1623,"correoUsuario":"munilaesperanzalaip@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Jennifer Monzon","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":179,"municipio":"La Esperanza","deptoCreador":0,"muniInformador":796,"departamentoInformador":13,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\468247322.pdf"},{"id":1624,"correoUsuario":"solmarti1995@gmail.com123","estadosId":2,"estado":"Inactivo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Amanda Soledad Ortiz Martinez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":106,"municipio":"San Ildefonso Ixtahuacán","deptoCreador":0,"muniInformador":797,"departamentoInformador":8,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1520946025.pdf"},{"id":1625,"correoUsuario":"jmixchop85@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"José Manuel Ixchop Hernández","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":326,"municipio":"San Francisco El Alto","deptoCreador":0,"muniInformador":798,"departamentoInformador":21,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\2107978449.pdf"},{"id":1626,"correoUsuario":"desarrolloterritorial2428@outlook.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Mirna Janeth Ramos de Bardales","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":332,"municipio":"Gualán","deptoCreador":0,"muniInformador":799,"departamentoInformador":22,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\599147071.pdf"},{"id":1627,"correoUsuario":"tobarliseth7@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Dayana Liseth Tobar Ipiña","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":337,"municipio":"San Jorge","deptoCreador":0,"muniInformador":800,"departamentoInformador":22,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1403837728.pdf"},{"id":1628,"correoUsuario":"oficinaordenterritorial@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Mirna Janeth Ramos de Bardales","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":332,"municipio":"Gualán","deptoCreador":0,"muniInformador":801,"departamentoInformador":22,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\2058125586.pdf"},{"id":1629,"correoUsuario":"dmpsanjorge@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Dayana Liseth Tobar Ipiña","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":337,"municipio":"San Jorge","deptoCreador":0,"muniInformador":802,"departamentoInformador":22,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1896472537.pdf"},{"id":1630,"correoUsuario":"jorge.mejia@muniesquipulas.gob.gt","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Jorge Luis Mejía Rodríguez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":45,"municipio":"Esquipulas","deptoCreador":0,"muniInformador":803,"departamentoInformador":4,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\288337850.pdf"},{"id":1632,"correoUsuario":"granadospadillamc@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"María Carolina Granados Padilla","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":43,"municipio":"Chiquimula","deptoCreador":0,"muniInformador":804,"departamentoInformador":4,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1786506189.pdf"},{"id":1633,"correoUsuario":"capn449@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Carlos Alfredo Peñalonzo Nájera","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":181,"municipio":"Palestina de Los Altos","deptoCreador":0,"muniInformador":805,"departamentoInformador":13,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\853197614.pdf"},{"id":1634,"correoUsuario":"omdmunisj@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Karla María Sagastume Espino De Coronado","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":51,"municipio":"San José la Arada","deptoCreador":0,"muniInformador":806,"departamentoInformador":4,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1934375458.pdf"},{"id":1635,"correoUsuario":"estuardomiguel83@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Miguel Estuardo García Gonzáles","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":52,"municipio":"San Juan Ermita","deptoCreador":0,"muniInformador":807,"departamentoInformador":4,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1218900888.pdf"},{"id":1636,"correoUsuario":"jandregcastillo@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Jerlyn Jasmine Castillo Mayorga","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":48,"municipio":"Olopa","deptoCreador":0,"muniInformador":808,"departamentoInformador":4,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\631162406.pdf"},{"id":1637,"correoUsuario":"ladyperez.705@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Cinthia Ladysol Pérez Rámos","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":50,"municipio":"San Jacinto","deptoCreador":0,"muniInformador":809,"departamentoInformador":4,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1560741209.pdf"},{"id":1638,"correoUsuario":"uaimconcepcion@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Wuendy Olivia Portillo Lémus","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":44,"municipio":"Concepción Las Minas","deptoCreador":0,"muniInformador":810,"departamentoInformador":4,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1818859426.pdf"},{"id":1640,"correoUsuario":"wiliam.garcia1985@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Wiliam García Pérez","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":47,"municipio":"Jocotán","deptoCreador":0,"muniInformador":811,"departamentoInformador":4,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\744211836.pdf"},{"id":1641,"correoUsuario":"secretaria@muniquezaltepeque.gob.gt","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Mirna Nataly López Archila","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":49,"municipio":"Quetzaltepeque","deptoCreador":0,"muniInformador":812,"departamentoInformador":4,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1019865767.pdf"},{"id":1642,"correoUsuario":"lucianoxajil12@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"luciano.xajil","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":291,"municipio":"San Pablo La Laguna","deptoCreador":0,"muniInformador":813,"departamentoInformador":19,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1541654022.pdf"},{"id":1643,"correoUsuario":"julioeovides91@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Julio Ernesto Ortiz Vides","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":46,"municipio":"Ipala","deptoCreador":0,"muniInformador":814,"departamentoInformador":4,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\616608050.pdf"},{"id":1644,"correoUsuario":"polivasank1980@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Sandra Karolina Perez oliva","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":162,"municipio":"San Benito","deptoCreador":0,"muniInformador":815,"departamentoInformador":12,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\825239733.pdf"},{"id":1645,"correoUsuario":"luzmacario5001@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"MARIA LUZ MACARIO TOL","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":195,"municipio":"Chiché","deptoCreador":0,"muniInformador":816,"departamentoInformador":14,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\1154992363.pdf"},{"id":1654,"correoUsuario":"mendezabner420@gmail.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Abner Esaú Méndez Romero","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":186,"municipio":"San Juan Ostuncalco","deptoCreador":0,"muniInformador":817,"departamentoInformador":13,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\327714422.pdf"},{"id":1656,"correoUsuario":"wosamib210@dosbee.com","estadosId":1,"estado":"Activo","institucionesId":null,"nombreInstitucion":null,"nombreUsuario":"Alexander Chali","telefono":null,"puestosId":5,"nombrePuesto":"Enlace Municipal","roles":[{"rolesId":4,"nombreRol":"Informador Municipal"}],"departamentoCreadorId":0,"departamentoCreador":null,"municipiosId":225,"municipio":"Antigua Guatemala","deptoCreador":0,"muniInformador":818,"departamentoInformador":16,"pathDocumentoRespaldo":"\\documentos\\municipalidades\\informadores\\respaldos\\665784851.pdf"},];
const revisores = [
  {
    "id": 988,
    "correoUsuario": "luismadriles@gmail.com",
    "estadosId": 2,
    "estado": "Inactivo",
    "institucionesId": 15,
    "nombreInstitucion": null,
    "nombreUsuario": "Luis Madriles ",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 991,
    "correoUsuario": "samendez@marn.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 16,
    "nombreInstitucion": "Ministerio de Ambiente y Recursos Naturales",
    "nombreUsuario": "Sergio Méndez",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 993,
    "correoUsuario": "jmestrada@marn.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 16,
    "nombreInstitucion": "Ministerio de Ambiente y Recursos Naturales",
    "nombreUsuario": "Jorge Mario Estrada Asturias",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 995,
    "correoUsuario": "ntreu.aguaysaneamiento@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Mónica Paola Mazariegos de la Loma",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 996,
    "correoUsuario": "aabarrientos@marn.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 16,
    "nombreInstitucion": "Ministerio de Ambiente y Recursos Naturales",
    "nombreUsuario": "Alison Amarayni Barrientos Castañeda de Chinchilla",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Aprobador"
      },
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 999,
    "correoUsuario": "oasretalhuleu@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Gonzalo Leonel Mérida Esteban",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1000,
    "correoUsuario": "ccastaneda@ric.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 18,
    "nombreInstitucion": "Registro de Información Catastral",
    "nombreUsuario": "Cristian Manuel Castañeda Tomas",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1001,
    "correoUsuario": "kjgomez@conred.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 20,
    "nombreInstitucion": "Secretaria Ejecutiva Coordinadora Nacional para la Reducción de Desastres",
    "nombreUsuario": "Karla Gómez",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1002,
    "correoUsuario": "enmaepineda@gmail.com",
    "estadosId": 2,
    "estado": "Inactivo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Enma Pineda",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1003,
    "correoUsuario": "eyfigueroa@conred.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 20,
    "nombreInstitucion": "Secretaria Ejecutiva Coordinadora Nacional para la Reducción de Desastres",
    "nombreUsuario": "Enma Yanira Figueroa",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1004,
    "correoUsuario": "emmorales@marn.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 16,
    "nombreInstitucion": "Ministerio de Ambiente y Recursos Naturales",
    "nombreUsuario": "Elsa Maria Morales Chacón",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1005,
    "correoUsuario": "cagarcia@conred.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 20,
    "nombreInstitucion": "Secretaria Ejecutiva Coordinadora Nacional para la Reducción de Desastres",
    "nombreUsuario": "Carmen García",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1006,
    "correoUsuario": "vjorozco@marn.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 16,
    "nombreInstitucion": "Ministerio de Ambiente y Recursos Naturales",
    "nombreUsuario": "Victor Josué Orozco Godínez",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1007,
    "correoUsuario": "cfcastro@conred.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 20,
    "nombreInstitucion": "Secretaria Ejecutiva Coordinadora Nacional para la Reducción de Desastres",
    "nombreUsuario": "Carlos Castro",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1008,
    "correoUsuario": "lmlopez@conred.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 20,
    "nombreInstitucion": "Secretaria Ejecutiva Coordinadora Nacional para la Reducción de Desastres",
    "nombreUsuario": "Luz María López",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1009,
    "correoUsuario": "zmquim@marn.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 16,
    "nombreInstitucion": "Ministerio de Ambiente y Recursos Naturales",
    "nombreUsuario": "Zurielh Manuel Francisco Quim Tiu",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1010,
    "correoUsuario": "varias@infom.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Victor Arias",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1011,
    "correoUsuario": "javierconsultores@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 18,
    "nombreInstitucion": "Registro de Información Catastral",
    "nombreUsuario": "Javiern Bal ",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1012,
    "correoUsuario": "aaramirez@marn.gob.gt;",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 16,
    "nombreInstitucion": "Ministerio de Ambiente y Recursos Naturales",
    "nombreUsuario": "Allan Antonio Ramirez Ba",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1013,
    "correoUsuario": "hmfernandez@conred.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 20,
    "nombreInstitucion": "Secretaria Ejecutiva Coordinadora Nacional para la Reducción de Desastres",
    "nombreUsuario": "Helen Fernández",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1014,
    "correoUsuario": "aaramirez@marn.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 16,
    "nombreInstitucion": "Ministerio de Ambiente y Recursos Naturales",
    "nombreUsuario": "Allan Antonio Ramirez Ba",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1015,
    "correoUsuario": "jmtipaz@conred.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 20,
    "nombreInstitucion": "Secretaria Ejecutiva Coordinadora Nacional para la Reducción de Desastres",
    "nombreUsuario": "Jorge Mario Tipaz",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1016,
    "correoUsuario": "dmmoran@conred.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 20,
    "nombreInstitucion": "Secretaria Ejecutiva Coordinadora Nacional para la Reducción de Desastres",
    "nombreUsuario": "Diego Morán",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1017,
    "correoUsuario": "ingenieriasostenible17@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 18,
    "nombreInstitucion": "Registro de Información Catastral",
    "nombreUsuario": "Selvyn Colon",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1018,
    "correoUsuario": "jatzun@marn.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 16,
    "nombreInstitucion": "Ministerio de Ambiente y Recursos Naturales",
    "nombreUsuario": "José Andres Tzún Chanchavac",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1019,
    "correoUsuario": "soyfelixmelgar@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 18,
    "nombreInstitucion": "Registro de Información Catastral",
    "nombreUsuario": "Felix Armando Melgar Hernandez",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1020,
    "correoUsuario": "ksortiz@conred.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 20,
    "nombreInstitucion": "Secretaria Ejecutiva Coordinadora Nacional para la Reducción de Desastres",
    "nombreUsuario": "Karen Sucely Ortíz",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1021,
    "correoUsuario": "cac@ric.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 18,
    "nombreInstitucion": "Registro de Información Catastral",
    "nombreUsuario": "Claudia Maribel Ac Bin",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1023,
    "correoUsuario": "cfsic@marn.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 16,
    "nombreInstitucion": "Ministerio de Ambiente y Recursos Naturales",
    "nombreUsuario": "Carlos Francisco Sic García",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1024,
    "correoUsuario": "ddivas@ric.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 18,
    "nombreInstitucion": "Registro de Información Catastral",
    "nombreUsuario": "Deivy Adalid Divas Duque",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1025,
    "correoUsuario": "juanmerida21@yahoo.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Rodrigo Mérida Arce",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Aprobador"
      },
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1026,
    "correoUsuario": "eflores@infom.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Elsa Ruth Flores",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1027,
    "correoUsuario": "lfigueroa@infom.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Luz Elena Figueroa",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1028,
    "correoUsuario": "jareline20@gmail.com",
    "estadosId": 2,
    "estado": "Inactivo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Leonor Rodriguez",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1029,
    "correoUsuario": "oas.ddrissi@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Jennifer Janeth Cháves González",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1030,
    "correoUsuario": "pabloduarte04@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 18,
    "nombreInstitucion": "Registro de Información Catastral",
    "nombreUsuario": "Pablo Daniel Duarte Durán",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1031,
    "correoUsuario": "hermacarrera@gmail.com",
    "estadosId": 2,
    "estado": "Inactivo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Maribel Carrera",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1032,
    "correoUsuario": "mmanuelsamayoa@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Manuel Samayoa",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1034,
    "correoUsuario": "igallardo@infom.gob.gt",
    "estadosId": 2,
    "estado": "Inactivo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Ivonne Gallardo",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1035,
    "correoUsuario": "javierramos.rm@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Francisco Javier Ramos Díaz",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1036,
    "correoUsuario": "walfredcordero@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Walfred Bladimir Cordero Useli",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1037,
    "correoUsuario": "catonocalderon@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Carlos Antonio Calderón Villeda",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1038,
    "correoUsuario": "wendyramirez94@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Wendy Leticia Ramirez Vega",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1039,
    "correoUsuario": "jehernandez@marn.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 16,
    "nombreInstitucion": "Ministerio de Ambiente y Recursos Naturales",
    "nombreUsuario": "Jesus Hernandez",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1040,
    "correoUsuario": "vjaldana@marn.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 16,
    "nombreInstitucion": "Ministerio de Ambiente y Recursos Naturales",
    "nombreUsuario": "Victor Josue Aldana Mayorga",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1041,
    "correoUsuario": "Kmtax@marn.gob.gt",
    "estadosId": 2,
    "estado": "Inactivo",
    "institucionesId": 16,
    "nombreInstitucion": "Ministerio de Ambiente y Recursos Naturales",
    "nombreUsuario": "Keisy Melissa Tax Hernández",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1042,
    "correoUsuario": "josegonzalez7899jg@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Juan José Sazo González",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1043,
    "correoUsuario": "delvam08@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Carlos Eduardo del Valle Mejía",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1044,
    "correoUsuario": "jrmazariegos@marn.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 16,
    "nombreInstitucion": "Ministerio de Ambiente y Recursos Naturales",
    "nombreUsuario": "Jorge Raul Mazariegos Calderon",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1045,
    "correoUsuario": "cytax@marn.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 16,
    "nombreInstitucion": "Ministerio de Ambiente y Recursos Naturales",
    "nombreUsuario": "Cary Yugassminy Tax Hernández",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1046,
    "correoUsuario": "bmmerida@marn.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 16,
    "nombreInstitucion": "Ministerio de Ambiente y Recursos Naturales",
    "nombreUsuario": "Blanca Marina Mérida Maldonado",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1047,
    "correoUsuario": "lmlopez@marn.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 16,
    "nombreInstitucion": "Ministerio de Ambiente y Recursos Naturales",
    "nombreUsuario": "Luis Miguel Lopez Ventura",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1048,
    "correoUsuario": "hhochoa@marn.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 16,
    "nombreInstitucion": "Ministerio de Ambiente y Recursos Naturales",
    "nombreUsuario": "Helio Hiram Ochoa Escobar",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1049,
    "correoUsuario": "mserrano@marn.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 16,
    "nombreInstitucion": "Ministerio de Ambiente y Recursos Naturales",
    "nombreUsuario": "Mariangelica Serrano García ",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1050,
    "correoUsuario": "tutor00865@galileo.edu",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "William Rodrigo Abad Marin",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1051,
    "correoUsuario": "ericloes87@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Eric Rubén López Escobar",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1052,
    "correoUsuario": "jair.morales28@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Jair Eliezer Pirir Morales",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1053,
    "correoUsuario": "femarcosg@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Felipe Pedro Marcos Gallego",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1054,
    "correoUsuario": "andrealaynez05@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Juana Andrea Laynez Zuñiga",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1055,
    "correoUsuario": "norma.lidia@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Norma Lidia Chij Espinoza de Vaidés",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1056,
    "correoUsuario": "liligomez547@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Santos Liliana Gómez Felipe",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1057,
    "correoUsuario": "infosaneamiento@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Noe Rodolfo González Martínez",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1058,
    "correoUsuario": "misaelflores099@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Robinson Misael García Flores",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1059,
    "correoUsuario": "isaelvincontreras@hotmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Elvin Magdiel Contreras",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1060,
    "correoUsuario": "elisaromanlara21@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Elisa Aurora Román Lara",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1062,
    "correoUsuario": "Dirrael21@yahoo.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Irrael De la Cruz Vela",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1063,
    "correoUsuario": "clarissaruano702@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Sayda Clarissa Ruano Girón",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1064,
    "correoUsuario": "saludyambientexela@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Olver Eduardo Morales Cifuentes",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1065,
    "correoUsuario": "vigilanciadvcrs212@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Josue Moises Chavez Camposeco",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1066,
    "correoUsuario": "ivaniglesias1184@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Iván Baudilio Iglesias Menendez",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1067,
    "correoUsuario": "gasparesteban73@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Jeysson Esteban Gaspar Menchú",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1068,
    "correoUsuario": "ivania30793@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Ivania Ninoska Karislandia Alvarado",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1069,
    "correoUsuario": "ballyasmin0317@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Yasmin Bal Pichol",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1070,
    "correoUsuario": "eimariela.ot@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Elien Ollej Tepaz",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1071,
    "correoUsuario": "ff4lexis@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Fausto Catú Morales",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1072,
    "correoUsuario": "ludyorellana@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Ludy Esmeralda Orellana Cabrera",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1073,
    "correoUsuario": "alfasoriano@hotmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Aníbal Roberto Soriano Ramírez",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1074,
    "correoUsuario": "zebbrey@hotmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Darwin Roberto Reyes García",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1075,
    "correoUsuario": "waldecoloch@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Waldemar Coloch González",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1076,
    "correoUsuario": "dpsaltaverapaz@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Allan Israel Laj Hun",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1077,
    "correoUsuario": "saneamiento.dass@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Edgar Enrique Vega García",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1078,
    "correoUsuario": "gaehingenieria@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Gustavo Adolfo Estrada Hurtarte",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1079,
    "correoUsuario": "ticoraul@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Raúl Ernesto Molina Vargas",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1080,
    "correoUsuario": "atencionalambienteddrissav@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Luis Manuel López Vielman",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1081,
    "correoUsuario": "gab4812@hotmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Gustavo Adolfo Bermudez",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1082,
    "correoUsuario": "autorizacionessanitariaddrisse@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Edgar Rolando López Hernández",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1083,
    "correoUsuario": "secciondeaguaesc@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Blanca Ernestina Ramos Ramírez",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1084,
    "correoUsuario": "oliverioleonmedrano@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Benjamin Oliverio León Medrano",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1085,
    "correoUsuario": "saneamientoambientalsayaxche@hotmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Fredy Noé Martínez Revolorio",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1086,
    "correoUsuario": "moisescarmenate820@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Evaristo Moises Carmenate Requena",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1087,
    "correoUsuario": "apz_perez@yahoo.com",
    "estadosId": 2,
    "estado": "Inactivo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Abelardo Pérez Zamora",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1088,
    "correoUsuario": "yosimaralexfu19@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Yosimar Alexhander Fuentes López",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1089,
    "correoUsuario": "ing.marvinponcio@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Marvin Santiago Poncio Pop",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1090,
    "correoUsuario": "tonotsr@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Antonio Federico Tambriz Cuc",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1091,
    "correoUsuario": "apz_perez@yahoo.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Abelardo Pérez Zamora",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1092,
    "correoUsuario": "sanea_nororiente@yahoo.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Rodulfo Paul Cano",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1093,
    "correoUsuario": "saneamientoambientaldaschiqui@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Adolfo Josué Franco Lémus",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1094,
    "correoUsuario": "isacsmorazan@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Edenilson Asencio Carias",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1095,
    "correoUsuario": "dvcrsizabal.mspas@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "German Fredy Diaz Gonzáles",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1096,
    "correoUsuario": "yunyerfredi3247@hotmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Yunyer Fredy Choc Acam",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1097,
    "correoUsuario": "supervisionstsrdas@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Angel Rodolfo Peña Tunche",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1098,
    "correoUsuario": "escobarleisar@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Leisar Amilcar de la Cruz Escobar",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1099,
    "correoUsuario": "departamentodvcrs@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Yunior Glomery Martinez Monroy",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1101,
    "correoUsuario": "antonioguare7398@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Walter Antonio Guaré García",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1102,
    "correoUsuario": "saneamientodrrissgsareasur@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Walter Antonio Guaré Cárdenas",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1103,
    "correoUsuario": "jodel4828@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "José Fernando Rabanales de León",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1104,
    "correoUsuario": "mynor_cortez@hotmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Mynor Eduardo Cortez Espinoza",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1105,
    "correoUsuario": "ronylariosmyd@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Rony Neftaly Ixcopal Larios",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1106,
    "correoUsuario": "cordovarmando10@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Héctor Armando Cordova Alvarado",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1107,
    "correoUsuario": "jhonyalvarado@hotmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Jonatan Abisai Alvarado",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1108,
    "correoUsuario": "osmanmaas826@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Oscar Vinicio Maas",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1111,
    "correoUsuario": "revisor_aprobador2@amiguate.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 9,
    "nombreInstitucion": "Institución de consulta MDGM",
    "nombreUsuario": "Enlace",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1112,
    "correoUsuario": "karla.rodriquez@segeplan.gob.gt111",
    "estadosId": 2,
    "estado": "Inactivo",
    "institucionesId": 21,
    "nombreInstitucion": "Secretaría de Planificación y Programación de la Presidencia",
    "nombreUsuario": "Karla Ivonne Rodriquez Quiñonez222",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1113,
    "correoUsuario": "amdeomolina@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 18,
    "nombreInstitucion": "Registro de Información Catastral",
    "nombreUsuario": "Gregorio Escobar",
    "telefono": null,
    "puestosId": 5,
    "nombrePuesto": "Enlace Municipal",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1135,
    "correoUsuario": "edgar.valiente@segeplan.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 21,
    "nombreInstitucion": "Secretaría de Planificación y Programación de la Presidencia",
    "nombreUsuario": "Edgar Oswaldo Valiente Véliz",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1136,
    "correoUsuario": "eswin.archila@segeplan.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 21,
    "nombreInstitucion": "Secretaría de Planificación y Programación de la Presidencia",
    "nombreUsuario": "Eswin Oswaldo Archila Pirir",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1137,
    "correoUsuario": "maynor.figueroa@segeplan.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 21,
    "nombreInstitucion": "Secretaría de Planificación y Programación de la Presidencia",
    "nombreUsuario": "Maynor Oswaldo Figueroa Estrada",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1138,
    "correoUsuario": "nury.osteaga@segeplan.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 21,
    "nombreInstitucion": "Secretaría de Planificación y Programación de la Presidencia",
    "nombreUsuario": "Nury Concepción Osteaga Galindo",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1139,
    "correoUsuario": "erik.zelada@segeplan.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 21,
    "nombreInstitucion": "Secretaría de Planificación y Programación de la Presidencia",
    "nombreUsuario": "Erik Josué Zelada Salazar",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1140,
    "correoUsuario": "juan.laparra@segeplan.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 21,
    "nombreInstitucion": "Secretaría de Planificación y Programación de la Presidencia",
    "nombreUsuario": "Juan Luis Laparra Herrera ",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1141,
    "correoUsuario": "axel.esteban@segeplan.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 21,
    "nombreInstitucion": "Secretaría de Planificación y Programación de la Presidencia",
    "nombreUsuario": "Axel David Esteban Fuentes",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1142,
    "correoUsuario": "juan.contreras@segeplan.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 21,
    "nombreInstitucion": "Secretaría de Planificación y Programación de la Presidencia",
    "nombreUsuario": "Juan Carlos Contreras Villagrán",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1143,
    "correoUsuario": "sgonzalez@segeplan.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 21,
    "nombreInstitucion": "Secretaría de Planificación y Programación de la Presidencia",
    "nombreUsuario": "Salomón Gonzalez Garmendia ",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1144,
    "correoUsuario": "sheila.deleon@segeplan.gob.gt",
    "estadosId": 2,
    "estado": "Inactivo",
    "institucionesId": 21,
    "nombreInstitucion": "Secretaría de Planificación y Programación de la Presidencia",
    "nombreUsuario": "Sheila Olivia de León Benitez",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1145,
    "correoUsuario": "jorge.puac@segeplan.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 21,
    "nombreInstitucion": "Secretaría de Planificación y Programación de la Presidencia",
    "nombreUsuario": "Jorge Antonio Puac Rodas",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1146,
    "correoUsuario": "rchen@segeplan.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 21,
    "nombreInstitucion": "Secretaría de Planificación y Programación de la Presidencia",
    "nombreUsuario": "Ricardo Chen González",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1147,
    "correoUsuario": "diana.melgar@segeplan.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 21,
    "nombreInstitucion": "Secretaría de Planificación y Programación de la Presidencia",
    "nombreUsuario": "Diana Violeta Melgar Juarez",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1148,
    "correoUsuario": "francisco.sanchez@segeplan.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 21,
    "nombreInstitucion": "Secretaría de Planificación y Programación de la Presidencia",
    "nombreUsuario": "Francisco Emilio Sanchez Burgos ",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1149,
    "correoUsuario": "nazir.barrow@cunizab.edu.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 21,
    "nombreInstitucion": "Secretaría de Planificación y Programación de la Presidencia",
    "nombreUsuario": "Nazir Eduardo Barrow Ramirez",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1150,
    "correoUsuario": "cesarhuertas@segeplan.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 21,
    "nombreInstitucion": "Secretaría de Planificación y Programación de la Presidencia",
    "nombreUsuario": "César Augusto Huertas Rac",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1151,
    "correoUsuario": "julio.istupe@segeplan.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 21,
    "nombreInstitucion": "Secretaría de Planificación y Programación de la Presidencia",
    "nombreUsuario": "julio Roberto Istupe Ibañez",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1152,
    "correoUsuario": "luis.arana@segeplan.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 21,
    "nombreInstitucion": "Secretaría de Planificación y Programación de la Presidencia",
    "nombreUsuario": "Luis Alberto Arana Hernández",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1153,
    "correoUsuario": "raul.lemus@segeplan.gob.gt",
    "estadosId": 2,
    "estado": "Inactivo",
    "institucionesId": 21,
    "nombreInstitucion": "Secretaría de Planificación y Programación de la Presidencia",
    "nombreUsuario": "Raul Samuel Lemus Colocho",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1154,
    "correoUsuario": "csamatitlan@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Sarai Galvani Galvan",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1155,
    "correoUsuario": "centrodesaludsanmiguelpetapa@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Antonio Mazariegos",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1156,
    "correoUsuario": "distritodesaludmezquital.24hrs@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Robin Curruchich",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1157,
    "correoUsuario": "saneamientoambiental.213@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Nelida Lucía Sarat Vásquez",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Aprobador"
      },
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1158,
    "correoUsuario": "ochoaotto32@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Otto Vinicio Ochoa Cano",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1159,
    "correoUsuario": "saneamientosanfranciscozap@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Axel Ivan Mejía Isep",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1160,
    "correoUsuario": "isasanlorenzosuch@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Angel Gabriel Yax Aguilar",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1161,
    "correoUsuario": "saneamientosangabriel@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Cristian Carlos Eduardo Rodríguez Farfán",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1162,
    "correoUsuario": "ambientalsaneamiento59@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Otto Henri Guare Cárdenas",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1163,
    "correoUsuario": "ivetiamorente@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Melvi Ivette Morente",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1164,
    "correoUsuario": "bzapaluta@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Blanca Estani Zapaluta Tahual",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1165,
    "correoUsuario": "alvaroamilcarsalazar2015@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Álvaro Amílcar Salazar Choyol",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1166,
    "correoUsuario": "saneamientosjb2025@outlook.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Heimo Vladimir Barrios López",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1167,
    "correoUsuario": "henryarturoguarevillatoro@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Henry Arturo Guaré Villatoro",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1168,
    "correoUsuario": "saneamientosantodomingo1006@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "José Santiago Chocoj Elías",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1169,
    "correoUsuario": "jardyvasquez10@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Jardy Vásquez Ixquereu",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1170,
    "correoUsuario": "isasanpablo157@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Rudy Dinael Cox Quejnay",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1171,
    "correoUsuario": "mavinalexanderhernandez@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Marvin Alexander Hernández Ajanel",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1172,
    "correoUsuario": "isapueblonuevosuch2025@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Mercy Yaycira Esteban Ramirez",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1173,
    "correoUsuario": "lguare@yahoo.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Luis Alberto Guaré García",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1174,
    "correoUsuario": "joseazanon5@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "José Rodolfo Mazariegos Arañón",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1175,
    "correoUsuario": "inspectorpacheco76@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Gilberto Fernando Pacheo Flores",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1176,
    "correoUsuario": "noegranadosvela63@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Noé Granados Velas",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1183,
    "correoUsuario": "ygvelasquez@mspas.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Yesenia Velasquez",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1184,
    "correoUsuario": "rfmartinez@marn.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 16,
    "nombreInstitucion": "Ministerio de Ambiente y Recursos Naturales",
    "nombreUsuario": "Rony Felipe Martínez España",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1185,
    "correoUsuario": "ljroche@marn.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 16,
    "nombreInstitucion": "Ministerio de Ambiente y Recursos Naturales",
    "nombreUsuario": "Luis Javier Roche Lemus",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1186,
    "correoUsuario": "ortizjorg18@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Jorge Jeovani Ortiz Reyes",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1187,
    "correoUsuario": "juliomasam@yahoo.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Julio Roberto Mazariegos Monterroso",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1188,
    "correoUsuario": "domingosalvador2022@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Salvador Avilés Torrés",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1189,
    "correoUsuario": "wilson.godoy@segeplan.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 21,
    "nombreInstitucion": "Secretaría de Planificación y Programación de la Presidencia",
    "nombreUsuario": "Wison Vidal Godoy Ramírez",
    "telefono": null,
    "puestosId": 4,
    "nombrePuesto": "Especialista en Planificación y Ordenamiento T",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1191,
    "correoUsuario": "regulacionessanitarias.213@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Anica Sucely López Ambrocio",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1276,
    "correoUsuario": "jhonyalvarado92@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Jonatan Abisai Alvarado Melchor",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1277,
    "correoUsuario": "esvinhernandezhz123@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Esvin Francisco Hernández Primero",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1278,
    "correoUsuario": "lopezplinio985@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Plinio López",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1457,
    "correoUsuario": "ddrissagua266@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Héctor Noe Grijalva Dubón",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1458,
    "correoUsuario": "regulacionessanitarias266@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Hilmar Israel Guzmán Escobar",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1459,
    "correoUsuario": "william.sanchez@segeplan.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 21,
    "nombreInstitucion": "Secretaría de Planificación y Programación de la Presidencia",
    "nombreUsuario": "William Rolando Sanchez Perez",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1460,
    "correoUsuario": "giovani.velasquez@segeplan.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 21,
    "nombreInstitucion": "Secretaría de Planificación y Programación de la Presidencia",
    "nombreUsuario": " Giovani Velásquez Gómez",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1461,
    "correoUsuario": "luis.valle@segeplan.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 21,
    "nombreInstitucion": "Secretaría de Planificación y Programación de la Presidencia",
    "nombreUsuario": "Luis Armando Valle Martinez",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1462,
    "correoUsuario": "maria.orozco@segeplan.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 21,
    "nombreInstitucion": "Secretaría de Planificación y Programación de la Presidencia",
    "nombreUsuario": "María Isabel Orozco Orozco",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1463,
    "correoUsuario": "heber.ramos@segeplan.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 21,
    "nombreInstitucion": "Secretaría de Planificación y Programación de la Presidencia",
    "nombreUsuario": "Heber Misael Ramos Martín",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1517,
    "correoUsuario": "atejeda@infom.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Armida Tejeda Marroquín",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1519,
    "correoUsuario": "arqruiz.ecoarci@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Arnoldo Rene Ruiz Monzón",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1523,
    "correoUsuario": "lalexandergb@hotmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Luis Alexander Galindo Batres",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1524,
    "correoUsuario": "ccmario@gmail.com",
    "estadosId": 2,
    "estado": "Inactivo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Carlos Mario Marroquín",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1525,
    "correoUsuario": "evffuentes@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Elmer Vitelio Fuentes Fuentes",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1526,
    "correoUsuario": "jfarfan@infom.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Jesica Liseth Farfán Mendoza",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1527,
    "correoUsuario": "primerojuliocalderon@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Julio René Calderón Flores",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1528,
    "correoUsuario": "kmilian@infom.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Karla Margarita Milian",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1529,
    "correoUsuario": "lvelasquez@infom.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Luz María Velásquez Coyoy",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1530,
    "correoUsuario": "mariolopez2@hotmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Mario Arturo Lopez",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1531,
    "correoUsuario": "marvinhernandez.infom@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Marvin René Hernández",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Aprobador"
      },
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1532,
    "correoUsuario": "mmassella@infom.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Melvin Estuardo Massella Pineda",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1533,
    "correoUsuario": "mmsandra13@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Sandra Patricia Martínez Mejía",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1534,
    "correoUsuario": "tmoreira@infom.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Thomas Alexander Moreira Ochaeta",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1535,
    "correoUsuario": "dvelas@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Verónica Taracena Gil de Velasquez",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1538,
    "correoUsuario": "cbarrientos.infom@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Carlos Fernando Barrientos Bailón",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1539,
    "correoUsuario": "jalcum@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Amado Josué López Cumatzil",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1540,
    "correoUsuario": "aurizar@infom.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Andrea Paulina Urizar López",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1544,
    "correoUsuario": "angelicasapon.infom@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Angelica Clarita de los Angeles Sapón",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1546,
    "correoUsuario": "asuy@infom.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Angélica Lourdes Suy Noj de Calderón",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1549,
    "correoUsuario": "angellopezinfom@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Antonio de Jesús Angel López",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1551,
    "correoUsuario": "blancarecinos.infom@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Blanca Evelia Lopez Recinos",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1553,
    "correoUsuario": "beatrizcordova.infom@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Blanca Beatriz C´rdova Cardona",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1556,
    "correoUsuario": "cesarmorales1603@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Cesar Eduardo Morales Rodriguez",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1558,
    "correoUsuario": "claudisoza105@hotmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Claudia María Soza",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1561,
    "correoUsuario": "cristopherhernandez.infom@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Cristopher D'Jesus Hernández Flores",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1563,
    "correoUsuario": "carranzajos12@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Darwin Josué Carranza Orellana",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1566,
    "correoUsuario": "evillagran@infom.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Edna Patricia Villagrán Ortiz",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1567,
    "correoUsuario": "hugomatul@hotmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Hugo Javier Matul Pérez",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1568,
    "correoUsuario": "hugomarroquin.infom@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Hugo José Marroquín Antón",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1569,
    "correoUsuario": "hugolbarrios@hotmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Hugo Mardoqueo López Barrios",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1570,
    "correoUsuario": "lorenanavarijo.infom@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Ingrid Lorena Navarijo Gaitán",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1571,
    "correoUsuario": "jairogudiel.infom@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Jairo Osmar Gudiel Lopez",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1572,
    "correoUsuario": "jnatareno@infom.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Josué Gabriel Natareno Alvarez",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1573,
    "correoUsuario": "juliorodm@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Julio Adolfo Rodriguez Merida",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1574,
    "correoUsuario": "justoenrique@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Justo Enrique Medrano Pérez",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1575,
    "correoUsuario": "milslui@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Luis Gustavo Cardona González",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1576,
    "correoUsuario": "marisa-noguera@hotmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Marisa Yomara Noguera Barrerra",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1577,
    "correoUsuario": "mrodriguez@infom.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Marly Elizabeth Rodriguez Ehmke",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1578,
    "correoUsuario": "nrangel@infom.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Nancy Patricia Rangél Reyes",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1579,
    "correoUsuario": "nidiabeatrizlopez29@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Nidia Beatríz López Raymundo",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1580,
    "correoUsuario": "nvelasquez@infom.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Nuvia Patricia Velásquez Serrano",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1581,
    "correoUsuario": "susethmartinez.infom@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Olga Suseth Martínez Acevedo de Lobos",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1582,
    "correoUsuario": "obarrios@infom.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Osmar Roderico Barrios Orozco",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1583,
    "correoUsuario": "revisor_aprobador_rgm@amiguate.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 21,
    "nombreInstitucion": "Secretaría de Planificación y Programación de la Presidencia",
    "nombreUsuario": "Revisor Aprobador",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1612,
    "correoUsuario": "karla.rodriguez@segeplan.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 21,
    "nombreInstitucion": "Secretaría de Planificación y Programación de la Presidencia",
    "nombreUsuario": "Karla Ivonne Rodriquez Quiñonez",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1613,
    "correoUsuario": "oeocana@marn.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 16,
    "nombreInstitucion": "Ministerio de Ambiente y Recursos Naturales",
    "nombreUsuario": "Omar Eduardo Ocaña Ozaeta",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1614,
    "correoUsuario": "nacuc@marn.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 16,
    "nombreInstitucion": "Ministerio de Ambiente y Recursos Naturales",
    "nombreUsuario": "Nelson Abelardo Cuc Coc",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1639,
    "correoUsuario": "folgarmario1818@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 18,
    "nombreInstitucion": "Registro de Información Catastral",
    "nombreUsuario": "Mario Folgar",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1646,
    "correoUsuario": "zreyes@marn.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 16,
    "nombreInstitucion": "Ministerio de Ambiente y Recursos Naturales",
    "nombreUsuario": "Wendy Zulema Ceballos Reyes",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1647,
    "correoUsuario": "maherrera@marn.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 16,
    "nombreInstitucion": "Ministerio de Ambiente y Recursos Naturales",
    "nombreUsuario": "Maria Andrea Herrera Ramírez",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1649,
    "correoUsuario": "gacsale@hotmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 9,
    "nombreInstitucion": "Institución de consulta MDGM",
    "nombreUsuario": "Alexander Chali",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1650,
    "correoUsuario": "mgcontreras@marn.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 16,
    "nombreInstitucion": "Ministerio de Ambiente y Recursos Naturales",
    "nombreUsuario": "Mildred Guisela Contreras Vasquez",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1651,
    "correoUsuario": "jmcetino@marn.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 16,
    "nombreInstitucion": "Ministerio de Ambiente y Recursos Naturales",
    "nombreUsuario": "José Miguel Cetino López",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1652,
    "correoUsuario": "erchapas@marn.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 16,
    "nombreInstitucion": "Ministerio de Ambiente y Recursos Naturales",
    "nombreUsuario": "Esdras Rafael Chapas de Paz",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      }
    ]
  },
  {
    "id": 1653,
    "correoUsuario": "iamejia@marn.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 16,
    "nombreInstitucion": "Ministerio de Ambiente y Recursos Naturales",
    "nombreUsuario": "Ivan Adnres Mejía Porras",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1657,
    "correoUsuario": "cchen@infom.gob.gt",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "nombreUsuario": "Ceciah Yesminnia Chen Fuentes",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Aprobador"
      }
    ]
  },
  {
    "id": 1658,
    "correoUsuario": "tono.tsr@gmail.com",
    "estadosId": 1,
    "estado": "Activo",
    "institucionesId": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "nombreUsuario": "Antonio Tambriz",
    "telefono": null,
    "puestosId": 2,
    "nombrePuesto": "Representante Institución",
    "roles": [
      {
        "nombreRol": "Revisor"
      },
      {
        "nombreRol": "Aprobador"
      }
    ]
  }
];

const masters = [
  {
    "id": 2,
    "nombreInstitucion": "Ministerio de Agricultura, Ganadería y Alimentación",
    "siglas": "MAGA",
    "telefono": "54820836",
    "pathDocumentoRespaldo": null,
    "estadosId": 1,
    "estado": "Activo",
    "correoUsuario": "lili@gmails.comsss",
    "nombreUsuario": "Ana Suseth Marroquin Méndezdsdsds",
    "usuariosId": 4,
    "telefonoUsuario": "54820836"
  },
  {
    "id": 7,
    "nombreInstitucion": "Ministerio de Comunicaciones, Infraestructura y Vivienda",
    "siglas": "CIV",
    "telefono": "52546471",
    "pathDocumentoRespaldo": null,
    "estadosId": 2,
    "estado": "Inactivo",
    "correoUsuario": "eporras@fopavi.gob.gt",
    "nombreUsuario": "Edgar Adolfo Porras y Porras",
    "usuariosId": 10,
    "telefonoUsuario": "52546471"
  },
  {
    "id": 18,
    "nombreInstitucion": "Registro de Información Catastral",
    "siglas": "RIC",
    "telefono": "59531076",
    "pathDocumentoRespaldo": null,
    "estadosId": 1,
    "estado": "Activo",
    "correoUsuario": "castillofirst@gmail.com",
    "nombreUsuario": "Jorge Castillo",
    "usuariosId": 992,
    "telefonoUsuario": "59531076"
  },
  {
    "id": 9,
    "nombreInstitucion": "Institución de consulta MDGM",
    "siglas": "MDGM",
    "telefono": "25044444",
    "pathDocumentoRespaldo": null,
    "estadosId": 1,
    "estado": "Activo",
    "correoUsuario": "amiguate@gmail.com",
    "nombreUsuario": "Rev MDGM",
    "usuariosId": 439,
    "telefonoUsuario": "25044444"
  },
  {
    "id": 21,
    "nombreInstitucion": "Secretaría de Planificación y Programación de la Presidencia",
    "siglas": "SEGEPLAN",
    "telefono": "50334247",
    "pathDocumentoRespaldo": null,
    "estadosId": 1,
    "estado": "Activo",
    "correoUsuario": "amiguate.gt@gmail.com",
    "nombreUsuario": "Amisadai Hernández",
    "usuariosId": 1100,
    "telefonoUsuario": "50334247"
  },
  {
    "id": 1664,
    "nombre": "Alexander Chali",
    "correo": "mesaxi8979@gicont.com",
    "roles": [
      {
        "idRol": 1,
        "nombreRol": "Master Institucional"
      }
    ],
    "institucion": "Prueba",
    "institucionId": 22,
    "estadoId": 1,
    "estado": "Activo",
    "puesto": "Admin Institución",
    "puestoId": 1,
    "departamentosId": 0,
    "departamento": null,
    "municipiosId": 0,
    "municipio": null,
    "token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjE2NjQiLCJlbWFpbCI6Im1lc2F4aTg5NzlAZ2ljb250LmNvbSIsInJvbGUiOiJNYXN0ZXIgSW5zdGl0dWNpb25hbCIsIm5iZiI6MTc4NDIzMzY2NywiZXhwIjoxNzg0ODM4NDY3LCJpYXQiOjE3ODQyMzM2Njd9.nbebpnfc0FCmSaPu-QozHWlDF1vNrEL0US6Hj_3mxUQ"
  },
  {
    "id": 17,
    "nombreInstitucion": "Ministerio de Salud Publica y Asistencia Social",
    "siglas": "MSPAS",
    "telefono": "42102466",
    "pathDocumentoRespaldo": null,
    "estadosId": 1,
    "estado": "Activo",
    "correoUsuario": "cvelasquez@mspas.gob.gt",
    "nombreUsuario": "Claudia Velazquez Melgar",
    "usuariosId": 989,
    "telefonoUsuario": "42102466",
    "nombre": "Alexander Chali",
    "correo": "cvelasquez@mspas.gob.gt",
    "roles": [
      {
        "idRol": 1,
        "nombreRol": "Master Institucional"
      }
    ],
    "institucion": "Prueba",
    "institucionId": 17,
    "estadoId": 1,
    "puesto": "Admin Institución",
    "puestoId": 1,
    "departamentosId": 0,
    "departamento": null,
    "municipiosId": 0,
    "municipio": null
  },
  {
    "id": 19,
    "nombreInstitucion": "Instituto de Fomento Municipal",
    "siglas": "INFOM",
    "telefono": "47703663",
    "pathDocumentoRespaldo": null,
    "estadosId": 1,
    "estado": "Activo",
    "correoUsuario": "mealvarez@infom.gob.gt",
    "nombreUsuario": "Melvin Omar Alvarez Rodríguez",
    "usuariosId": 994,
    "telefonoUsuario": "47703663",

    "roles": [
      {
        "idRol": 1,
        "nombreRol": "Master Institucional"
      }
    ],
    "correo": "mealvarez@infom.gob.gt",
    "institucion": "Prueba",
    "institucionId": 19,
    "estadoId": 1,
    "puesto": "Admin Institución",
    "puestoId": 1,
    "departamentosId": 0,
    "departamento": null,
    "municipiosId": 0,
    "municipio": null
  },
  {
    "id": 20,
    "nombreInstitucion": "Secretaria Ejecutiva Coordinadora Nacional para la Reducción de Desastres",
    "siglas": "SE-CONRED",
    "telefono": "59965629",
    "pathDocumentoRespaldo": null,
    "estadosId": 1,
    "estado": "Activo",
    "correoUsuario": "idmagana@conred.gob.gt",
    "nombreUsuario": "Irasema Magaña",
    "usuariosId": 997,
    "telefonoUsuario": "59965629"
  },
  {
    "id": 16,
    "nombreInstitucion": "Ministerio de Ambiente y Recursos Naturales",
    "siglas": "MARN",
    "telefono": "50180778",
    "pathDocumentoRespaldo": null,
    "estadosId": 1,
    "estado": "Activo",
    "correoUsuario": "mjhernandez@marn.gob.gt",
    "nombreUsuario": "María José Hernández",
    "usuariosId": 987,
    "telefonoUsuario": "50180778",
    "nombre": "María José Hernández",
    "correo": "mjhernandez@marn.gob.gt",
    "roles": [
      {
        "idRol": 1,
        "nombreRol": "Master Institucional"
      }
    ],
    "institucion": "Prueba",
    "institucionId": 16,
    "estadoId": 1,
    "puesto": "Admin Institución",
    "puestoId": 1,
    "departamentosId": 0,
    "departamento": null,
    "municipiosId": 0,
    "municipio": null
  }
];

const actions = {
  [LOGIN](context, credentials) {
// console.log(context);
// console.log("Fin 1");
// console.log(credentials.username);

    context.commit(PURGE_AUTH);
    
    return new Promise(resolve => {
      // console.log(credentials);
      ApiService.post(`apiconsume/create?endpoint=user/authenticate`, credentials)
        .then(({ data }) => {
          //  console.log(users);
          // informadores municipales

          //------------------ init bypass ------------------//

          // const user = users.find(u => u.correoUsuario === credentials.username);
          // console.log('user: ', user);
          // if (user === undefined) {
            
          //     const revisor = revisores.find(r => r.correoUsuario === credentials.username);
          //     console.log('revisor:', revisor);
          //     if (revisor !== undefined) {
          //       data = {
          //         message: "Usuario autenticado exitosamente",
          //         status: 200,
          //         data: revisor
          //       };
          //       data.data.token = data.data.token;
          //       data.data.estadoId = 1;
          //     } else {
          //       const master = masters.find(m => m.correoUsuario === credentials.username);
          //       console.log('master:', master);
          //       if (master !== undefined) {
          //         data = {
          //           message: "Usuario autenticado exitosamente",
          //           status: 200,
          //           data: master
          //         };
          //         data.data.token = data.data.token;
          //         data.data.estadoId = 1;
          //       }
          //     }
          // } else {
          //   data = {
          //     message: "Usuario autenticado exitosamente",
          //     status: 200,
          //     data: user
          //   };
          //   data.data.token = data.data.token;
          //   data.data.estadoId = 1;
          // }

          //------------------ end bypass ------------------//
          // console.log('data: ', data);

          if(data.status==200){
            context.commit(SET_AUTH, data.data);
            let stRoles = window.localStorage.getItem('roles');
            if(stRoles.includes(5)){
              context.commit(SET_CREADOR_DEPARTAMENTAL_VERIFY);
            }
            console.log('stRoles: ', stRoles);
            if(data.data.estadoId != 1){
              context.commit(PURGE_AUTH);
              resolve({status: 401, message: 'Usuario sin permisos de acceso'});
            }
            else{
              console.log('SET_INSTITUCION', SET_INSTITUCION);
              context.commit(SET_INSTITUCION);
              context.commit(SET_TOKEN);
            }
           
            
          }
          resolve(data);
        })
        .catch(({ response }) => {
          //console.log(response)
          context.commit(SET_ERROR, response);
          resolve(response);
        });
    });
  },
  [LOGOUT](context) {
    context.commit(PURGE_AUTH);
  },
  [REGISTER](context, credentials) {
    return new Promise(resolve => {
      ApiService.post("login", credentials)
        .then(({ data }) => {
          context.commit(SET_AUTH, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  },
  [VERIFY_AUTH](context) {
    
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return new Promise(resolve => {
      ApiService.get(`apiconsume/edit/${JwtService.getUserId()}?endpoint=api/Usuarios/`)
        .then(({ data }) => {
          
          if(data.status==200){
            //console.log(data.data.roles)
            context.commit(SET_AUTH2, data.data);
            context.commit(SET_CURRENT_ROLES, data.data.roles);
           
            let stRoles = window.localStorage.getItem('roles');
            if(stRoles.includes(5)){
              context.commit(SET_CREADOR_DEPARTAMENTAL_VERIFY);
            }
          } else {
            //window.location.replace('404')
          }    
          resolve();      
        })
        .catch(({ response }) => {
          
          console.log(response)
          context.commit(SET_ERROR, response.data);
        });
      });
    } else {
      context.commit(PURGE_AUTH);
    }
  },
  [UPDATE_PASSWORD](context, payload) {
    const password = payload;

    return ApiService.put("password", password).then(({ data }) => {
      context.commit(SET_PASSWORD, data);
      return data;
    });
  },

  [GET_CURRENT_USER](context) {
    return new Promise(resolve => {
      ApiService.get(`apiconsume/edit/${JwtService.getUserId()}?endpoint=api/Usuarios/`)
        .then(({ data }) => {
        
          if(data.status==200){
            //console.log(data.data.roles)
            context.commit(SET_CURRENT_USER, data.data);
            
           /* if(data.data.rolId===5){
              context.commit(SET_CREADOR_DEPARTAMENTAL);
            }*/
            context.commit(SET_INSTITUCION);
            context.commit(SET_TOKEN);
            
          }
          resolve(data);
        })
        .catch(({ response }) => {
          
          context.commit(SET_ERROR, response);
          resolve(response);
        });
    });
  },

};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_AUTH](state, user) {
    let arrRoles = user.roles.map(a => a.idRol);

    state.isAuthenticated = true;
    state.user = user;
    state.roles = arrRoles;
    state.errors = {};
    JwtService.saveUserId(state.user.id);
    JwtService.saveRoles(state.user.roles);
    JwtService.saveStateId(state.user.departamentosId);
    
  },

  [SET_AUTH2](state, user) {
    let arrRoles = user.roles.map(a => a.idRol);

    state.isAuthenticated = true;
    state.user = user;
    state.roles = arrRoles;
    state.errors = {};
    JwtService.saveUserId(state.user.id);
    JwtService.saveRoles(state.user.roles);
    //JwtService.saveStateId(state.user.departamentoCreadorId);
    
  },

  [SET_TOKEN](state) {
    JwtService.saveToken(state.user.token);
  },

  [SET_PASSWORD](state, password) {
    state.user.password = password;
  },

  [SET_CREADOR_DEPARTAMENTAL](state){
    JwtService.saveCreadorDepartamental({creadorDeptoNombre: state.user.departamento, creadorDepartamentoId: state.user.departamentosId});
  },

  [SET_CREADOR_DEPARTAMENTAL_VERIFY](state){
    JwtService.saveCreadorDepartamental({creadorDeptoNombre: state.user.departamentoCreador, creadorDepartamentoId: state.user.departamentoCreadorId});
  },

  [SET_INSTITUCION](state){
    JwtService.saveInstitucion({institucionesId: state.user.institucionId, institucion: state.user.institucion});
  },

  [SET_CURRENT_USER](state, user){
    state.currentUser = user;
  },

  [SET_CURRENT_ROLES](state, roles){
    state.currentRoles = roles;
  },

  [PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.user = {};
    state.errors = {};
    JwtService.destroyToken();
    JwtService.destroyUserId();
    JwtService.destroyCreadorDepartamental();
    JwtService.destroyRoles();
    JwtService.destroyInstitucion();
  }
};



export default {
  state,
  actions,
  mutations,
  getters
};
